export const CONST_URL_SEGEMENTS = {
    /*APIS THOSE CALLED DURING APPLICATION INITIATION.*/
    PUBLIC_APIS: [
        'i18n/.+',
        'companies/.+',
        'token',
        'recovery/password/lookup'
    ],

    BLOG_API: 'https://www.fitnessforce.com/blog/feed/',

    AUTH: {
        LOGIN_TOKEN: '/token',
        REFRESH_TOKEN: '/refresh',
        REVOKE_TOKEN: '/revoke',
        PASSWORD_LOOKUP: '/recovery/password/lookup',
        UNIQUE_IDENTIFIER: '/recovery/password/mail',
        PASSWORD_RESET: '/recovery/password/reset/'
    },

    INIT: {
        GET_LANG_INFO: '/get_info_lang',
        GET_COMPANY_INFO: '/company_info',
    },

    CLAIM: {
        GET_CLAIM_TEMPLATES: '/claim_templates',
        GET_ELIGIBEL_TEMPLATES: '/claim_templates/eligible_claim_templates'
    },

    SEARCH: {
        POST_SEARCH: '/search',
        POST_SEARCH_BY_TENANT_ID: '/tenants/{tenant_id}/search',
        POST_SEARCH_BY_COMPANY: '/companies/search',
        POST_SEARCH_BY_PROVIDER: '/tenants/{tenant_id}/search/providers/{provider_name}'
    },

    // Tenant apis
    TENANT: {
        GET_TENANT_LIST: '/tenants',
        GET_TENANTBYID: '/tenants',
        CREATE_TENANT: '/tenants',
        GET_TENANT_DEVICES:'/tenants/{tenantid}/devices',
        GET_TENANT_POS_DEVICES: '/tenants/{tenant_id}/pgw_config_master/ListOnlinePOS/{payment_gateway}',
        MARK_TENANT_ACTIVE: '/tenants/{tenant_id}/mark_as_active',
        MARK_TENANT_INACTIVE: '/tenants/{tenant_id}/mark_as_inactive',
        PATCH_TENANT: '/tenants/{tenant_id}',
        GET_CONTACTS: '/tenants/contacts',
    },

    STAFF: {
        GET_STAFF_LIST: '/staff',
        GET_STAFF_BYID: '/staff/{staff_id}',
        POST_CHANGE_PASSWORD: '/staff/{staff_id}/change_password',
        POST_CHANGE_PASSWORD_ME: '/me/change_password',
        POST_SUSPEND: '/staff/{staff_id}/mark_as_suspend',
        POST_TERMINATE: '/staff/{staff_id}/mark_as_terminate',
        POST_CHANGEOWNER: '/staff/{staff_id}/change_owner',
        POST_CHANGEREPORTINGMANAGER: '/staff/{staff_id}/change_reporting_manager',
        POST_CHANGECENTERACCESS: '/staff/{staff_id}/change_center_access',
        POST_ACTIVE: '/staff/{staff_id}/mark_as_active',
        POST_STAFF: '/staff',
        PUT_STAFF: '/staff/{staff_id}',
        STAFF_NOTIFICATIONS: '/staff/notification_subscription',
        GET_STAFF_NOTIFICATIONS: '/staff/notifications',
        MARK_STAFF_NOTIFICATION_AS_READ: '/tenants/{tenant_id}/staff/notifications/mark_as_read',
        MARK_STAFF_NOTIFICATION_AS_DELETE: '/tenants/{tenant_id}/staff/notifications/{notification_id}/mark_as_delete',
        REQUEST_ACCESS: '/tenants/{tenant_id}/request_access'
    },
    SMS: {
        SMS_TEMPLATE_MASTER: '/sms_template_master',
        SEND_SMS: '/send_sms'
    },
    USERS: {
        GET_USER_LIST: '/userList',
        STAFFS: '/staff/'
    },

    CLIENT: {
        POST_CLIENTS: '/tenants/{tenant_id}/clients',
        PATCH_CLIENTS: '/tenants/{tenant_id}/clients/{client_id}',
        POST_SPONSERS: '/tenants/{tenant_id}/corporate',
        POST_CLIENTS_FROM_CONTACT: '/tenants/{tenant_id}/contacts/{contact_id}/converttoprospect',
        GET_CLIENTS: '/clients',
        GET_ACTIVE_SUBSCRIPTION_CLIENTS: '/clients/active_clients',
        DELETE_CLIENTS: '/tenants/{tenant_id}/clients/{client_id}',
        ADD_TO_BLACKLIST: '/add_to_blacklist',
        REMOVE_FROM_BLACKLIST: '/remove_from_blacklist',
        CHANGE_CLIENT_REP: '/change_client_rep',
        SUBSCRIPTIONS: '/subscriptions',
        SUBSCRIPTION_SINGUPS: '/subscription_signups',
        INVOICES: '/invoices',
        PAYMENTS: '/payments',
        SALES_RETURNS: '/sales_returns',
        REFUND: '/refund',
        GET_REFUNDS: '/clients/{client_id}/refunds',
        CREATE_REFUND: '/tenants/{tenant_id}/clients/{client_id}/payment/{payment_id}/refund',
        VOID_REFUND: '/tenants/{tenant_id}/clients/{client_id}/Refund/{refund_id}/void',
        SEND_REFUND_PDF: '/clients/{client_id}/refund/{refund_id}/pdf_refund',
        GET_REFUND_PDF: '/clients/{client_id}/refund/{refund_id}/pdf_refund',
        CREATE_CREDIT_BALANCE_REFUND: '/tenants/{tenant_id}/clients/{client_id}/creditbalance/refund',
        PAYMENT_METHODS: '/stored_payment_methods',
        PAYMENT_TIMELINE: '/payment_timeline',
        STOP_BILLING: '/subscriptions/{clt_subs_id}/stop-billing',
        RESUME_BILLING: '/subscriptions/{clt_subs_id}/resume-billing',
        PATCH_SUBSCRIPTION: '/subscriptions/{clt_subs_id}',
        CLASS_APPT_TAGS: "/class_appt_tags",
        SERVICE_CAT: "/service_categories",
        IRREGULAR_CLIENTS: "/client_at_risk",
        INTERACTIONS: '/interactions',
        MIGRATION: '/migration_comments',
        RESET_PASSWORD: '/tenants/{tenant_id}/clients/{client_id}/reset_password',
        SESSION_INVENTORY: '/clients/{client_id}/session_inventory',
        ADD_CREDIT_BALANCE:'/tenants/{tenant_id}/clients/{client_id}/CreditBalance',
        GET_CREDIT_BALANCE:'/clients/{client_id}/CreditBalance',
        GET_CREDIT_BALANCE_BY_TENANT:'/tenants/{tenant_id}/clients/{client_id}/CreditBalance',
        GET_CREDIT_BALANCE_LIST:'/clients/{client_id}/centrewise_available_creditbalance',
        GET_CLIENT_REFERRALS:'/tenants/{tenant_id}/clients/{client_id}/referrals',
        GET_CLIENT_COUPONS:'/tenants/{tenant_id}/clients/{client_id}/get_eligible_coupons',
        GET_CLIENT_THREADS:'/tenants/{tenant_id}/threads',
        GET_CLIENT_FITNESS_DATA:'/tenant/{tenant_id}/get_sahha_health_score',
        VALIDATE_KEYFOB:'/tenant/{tenant_id}/validate_keyfob',
        DELETE_DIGITAL_KEYFOB:'/tenants/{tenant_id}/clients/{client_id}/access_pass',
        SYNC_TO_EXTERNAL_SYSTEMS: '/clients/{client_id}/sysc_to_all_external_systems',
        GET_GUEST_PASS_REDEMPTIONS: '/clients/{client_id}/guest_pass/redemptions',
        GET_GUEST_PASS_SUMMARY: '/clients/{client_id}/subscriptions/{clt_subs_id}/guest_pass',
        GET_SPONSERS: '/tenants/{tenant_id}/corporate/{sponsor_id}',
        UPDATE_SPONSERS: '/tenants/{tenant_id}/corporate/{sponsor_id}',
        GET_PROSPECTS: '/tenants/{tenant_id}/prospects',
        GET_EX_CLIENTS: '/tenants/{tenant_id}/exclients',
        PROSPECT_TRANSFER: '/tenants/{tenant_id}/clients/prospect_transfer',
        LIST_EXTERNAL_PROVIDERS: '/clients/{client_id}/external_provider',
        CREATE_EXTERNAL_PROVIDER: '/tenants/{tenant_id}/clients/{client_id}/external_provider',
        UPDATE_EXTERNAL_PROVIDER: '/tenants/{tenant_id}/clients/{client_id}/external_provider/{id}',
        DELETE_EXTERNAL_PROVIDER: '/tenants/{tenant_id}/clients/{client_id}/external_provider/{id}',
    },

    SERVICETYPE: {
        GET_SERVICETYPE: '/tenants/{tenant_id}/service_categories'
    },

    EXPECTED: {
        GET_EXPECTED_LIST: '/expected'
    },

    BALANCE_OVERDUE: {
        GET_BALANCEOVERDUE_LIST: '/balanceoverdue'
    },

    BIRTHDAY: {
        GET_BIRTHDAY_LIST: '/clients/birthdays'
    },

    COLLECTION: {
        GET_COLLECTION_LIST: '/collection'
    },

    FOLLOWUP: {
        GET_FOLLOWUP_LIST: '/followup'
    },

    IRREGULARMEMBER: {
        GET_IRREGULARMEMBER_LIST: '/clients/irregular'
    },

    ONLINETRANSACTION: {
        GET_ONLINETRANSACTION_LIST: '/onlinetransaction'
    },

    RENEWALDUE: {
        GET_RENEWALDUE_LIST: '/renewaldue'
    },

    OPPORTUNITY: {
        OPPORTUNITY: '/opportunities',
        CREATE_OPPORTUNITY: '/tenants/{tenant_id}/boards/{board_type}/opportunities',
        UPDATE_OPPORTUNITY: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}',
        GET_OPPORTUNITY: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}',
        DELETE_OPPORTUNITY: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}',
        MARK_AS_LOST: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}/mark_as_lost',
        MARK_AS_WON: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}/mark_as_won',
        MARK_AS_NURTURE: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}/mark_as_nurture',
        GET_OPPORTUNITIES: '/v2/tenants/{tenant_id}/boards/{board_type}/opportunities',
        CHANGE_STAGE: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}/change_stage/{stage_id}',
        CHANGE_ORDER: '/tenants/{tenant_id}/boards/{board_type}/opportunities/{opp_id}/sort_order'
    },

    OPPORTUNITYSTAGEMASTER: {
        OPPSTAGEMST: '/opp_stage_mst',
        GET_OPPORTUNITY_STAGE_MASTERS: '/tenants/{tenant_id}/boards/{board_type}/opp_stage_mst',
        GET_OPPORTUNITY_STAGE_MASTER: '/tenants/{tenant_id}/boards/{board_type}/opp_stage_mst/{stage_id}'
    },

    BOARDS: {
        TITLE: 'boards'
    },

    TASK: {
        GET_TASK: '/v2/tenants/{tenant_id}/tasks',
        POST_TASK_BY_CLIENT: '/tenants/{tenant_id}/clients/tasks',
        POST_RECURRING_TASK_BY_CLIENT: '/tenants/{tenant_id}/clients/recurring_tasks',
        POST_TASK_BY_OPPORTUNITY: '/tenants/{tenant_id}/opportunities/tasks',
        POST_RECURRING_TASK_BY_OPPORTUNITY: '/tenants/{tenant_id}/opportunities/recurring_tasks',
        CREATE_TOUR_OUTCOME_REQUEST: '',
        CREATE_CALL_OUTCOME_REQUEST: '',
        GET_TASK_BY_CLIENT_ID: '/clients/{client_id}/tasks',
        UPDATE_TASK: '/tenants/{tenant_id}/tasks/{task_id}',
        GET_TASK_BY_ID: '/tenants/{tenant_id}/tasks/{task_id}',
        BULK_DELETE_TASKS: '/tenants/{tenant_id}/tasks/bulk_delete',
        BULK_REASSIGN_TASKS: '/tenants/{tenant_id}/tasks/bulk_reassign',
        CREATE_CALL_OUTCOME: '/tenants/{tenant_id}/opportunity/call_outcome',
        CREATE_TOUR_OUTCOME: '/tenants/{tenant_id}/opportunity/tour_outcome',
    },

    COMMENTS: {
        CREATE_TASK_COMMENT: '/tenants/{tenant_id}/tasks/{task_id}/comments',
        DELETE_TASK_COMMENT: '/tenants/{tenant_id}/tasks/{task_id}/comments/{comment_id}'
    },

    TASKOUTCOME: {
        POST_CALL_OUTCOME: '/tenants/{tenant_id}/tasks/{tsk_id}/call_outcome',
        POST_TOUR_OUTCOME: '/tenants/{tenant_id}/tasks/{tsk_id}/tour_outcome'
    },

    TASKCATEGORY: {
        GETTASKCATEGORY: '/tenants/{tenant_id}/task_catagories',
        UPDATETASKCATEGORY: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}',
        MARKACTIVE: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}/mark_as_active',
        MARKINACTIVE: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}/mark_as_inactive',
        GETTASKCATEGORYBYID: '/tenants/{tenant_id}/task_catagories/{tsk_category_id}',
    },


    ROOM: {
        ROOM_LIST: "/tenants/{tenant_id}/rooms",
        ADD_ROOM: "/tenants/{tenant_id}/rooms"
    },

    SUBSCRIPTIONSIGNUP: {
        GET_COMPANY: '/subscription/signup/{sigup_sts_uuid}/company_details',
        GET_TENANT: '/subscription/signup/{sigup_sts_uuid}/tenants',
        GET_ORDERSUMMARY: '/subscription/signup/{sigup_sts_uuid}/get_order_summary',
        GET_ORDERDETAILS: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/subscription/signup/{sigup_sts_uuid}/get_order_subscription_detail',
        GET_ORDER_SUBSCRIPTION_STATUS: '/subscription/signup/{sigup_sts_uuid}/get_order_subscription_status',
        GET_ORDERSUMMARYBILLINGOCCURENCE: '/subscription/signup/{sigup_sts_uuid}/get_order_summary_billing_occurrence',
        POST_PROCEEDTOPAYMENT: '/subscription/signup/{sigup_sts_uuid}/proceed_to_payment',
        POST_SAVETOKEN: '/subscription/signup/{sigup_sts_uuid}/save_token',
        POST_SAVEEXTERNALTRANSACTIONID: '/subscription/signup/{sigup_sts_uuid}/save_external_transaction_id',
        PUT_CLIENTINFO: '/subscription/signup/{sigup_sts_uuid}/client_info',
        GET_WAIVERS: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/subscription/signup/{sigup_sts_uuid}/waivers',
        POST_WAIVERS: '/subscription/signup/{sigup_sts_uuid}/waivers',
        GET_CLIENT_MANDATORYFIELD: '/subscription/signup/{sigup_sts_uuid}/clients/mandatory_client_fields',
        GET_PAYMENTMETHODS: '/subscription/signup/{sigup_sts_uuid}/payment_methods',
        POST_OTP_TOKEN: '/subscription/signup/{sigup_sts_uuid}/payment_methods/{tokenid}/request_otp',
        GET_STAFF_AVAILABILITY_FOR_BOOKING: '/tenants/{sigup_sts_uuid}/appointments/{appointment_catagory_id}/availability',
        GET_TENANT_SETTINGS: '/tenants/{sigup_sts_uuid}/tenant_settings',
        BOOK_CONSULTATION: '/tenants/{sigup_sts_uuid}/appointments',
        GET_ELIGIBLE_ADDONS: '/open/tenants/{tenant_id}/subscription_plans/{plan_id}/eligible_addons',
        GET_APPOINTMENT_BY_UUID: '/open/companies/{company_id}/appointments/{appt_uuid}',
        GET_TOUR_BY_UUID: '/open/company/{company_id}/tour/{tour_uuid}',
        RESCHEDULE_APPOINTMENT_BY_UUID: '/open/companies/{company_id}/tenants/{tenant_id}/appointments/{appt_uuid}/reschedule_appointment',
        RESCHEDULE_TOUR_BY_UUID: '/open/company/{company_id}/tenants/{tenant_id}/tour/{tour_uuid}/reschedule_tour',
        GET_STAFF_AVAILABILITY_BY_APPOINTMENT_UUID: '/open/company/{company_id}/tenants/{tenant_id}/appointments/{appointment_catagory_id}/availability',
        GET_STAFF_AVAILABILITY_BY_TOUR_UUID: '/open/company/{company_id}/tenants/{tenant_id}/tour_availablity',
        VALIDATE_REFERRAL_CODE_BY_CODE: '/subscription/signup/{sigup_sts_uuid}/validate_code/{referral_code}',
        GET_SUBSCRIPTION_BY_UUID: '/subscriptions/{clt_subs_uuid}',
        GET_SUBSCRIPTION_INVOICES_BY_UUID: '/subscriptions/{clt_subs_uuid}/invoices',
        INITIATE_PAYMENT_METHOD_BY_UUID: '/subscriptions/{clt_subs_uuid}/initiate_update_payment_method',
        GET_INVOICE_BY_UUID: '/invoices/{invoice_uuid}',
        GENERATE_BALANCE_BY_UUID: '/invoices/{invoice_uuid}/generatebalanceuuid',
    },


    SCHEDULING: {
        APPOINTMENT: {
            GET_APPOINTMENTS: '/tenants/{tenant_id}/appointments',
            POST_APPOINTMENTS: '/tenants/{tenant_id}/appointments',
            POST_RECURRING_APPOINTMENTS: '/tenants/{tenant_id}/recurring_appt',
            GET_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}',
            PUT_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}',
            PUT_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}',
            SUBSTITUTE_COACH: '/tenants/{tenant_id}/appointments/{appt_id}/substitute_coach',
            SUBSTITUTE_COACH_RECURRING: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}/substitute_coach',
            RESCHEDULE_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}/reschedule_appointment',
            RESCHEDULE_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}/reschedule_appt',
            MARK_CLIENT_CHECKEDIN: '/tenants/{tenant_id}/appointments/{appt_id}/mark_client_checkedin',
            MARK_CLIENT_NOSHOW: '/tenants/{tenant_id}/appointments/{appt_id}/mark_client_noshow',
            CANCEL_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}/cancel_appointment',
            CANCEL_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}/cancel_appt',
            DELETE_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appt_id}',
            DELETE_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/recurring_appt/{appt_recurring_template_id}',
            UPDATE_APPOINTMENT_CLIENT_MEMBERSHIP: '/tenants/{tenant_id}/appointments/{appt_id}/change_client_membership',
            GET_APPOINTMENTS_CLIENT:"/tenants/{tenant_id}/clients/{client_id}/appointment_bookings",
            GET_APPOINTMENT_BOOKINGS_CLIENT_V2: '/v2/tenants/{tenant_id}/clients/{client_id}/appointment_bookings',
            GET_APPOINTMENT_BOOKING_DETAIL_V2: '/v2/tenants/{tenant_id}/clients/{client_id}/appointment_bookings/{appointment_id}',
            MARK_COMPLIMENTORY_APPOINTMENT:'/tenants/{tenant_id}/clients/{client_id}/comp_appointment/{appt_id}',
        },
        APPOINTMENT_TYPE: {
            GET_APPOINTMENT_TYPES: '/tenants/{tenant_id}/appointment_types',
            GET_APPOINTMENT_TYPE_BY_ID: '/tenants/{tenant_id}/appointment_types/{appt_type_id}',
            CREATE_APPOINTMENT_TYPE: '/tenants/{tenant_id}/appointment_types',
            UPDATE_APPOINTMENT_TYPE: '/tenants/{tenant_id}/appointment_types/{appt_type_id}',
            MARK_APPOINTMENT_TYPE_ACTIVE: '/tenants/{tenant_id}/appointment_types/{appt_type_id}/mark_as_active',
            MARK_APPOINTMENT_TYPE_INACTIVE: '/tenants/{tenant_id}/appointment_types/{appt_type_id}/mark_as_inactive',
            GET_APPOINTMENT_TAGS: '/tenants/{tenant_id}/class_appt_tags',
            GET_APPOINTMENT_TAG_BY_ID: '/tenants/{tenant_id}/class_appt_tags/{tag_id}',
            CREATE_APPOINTMENT_TAG: '/tenants/{tenant_id}/class_appt_tags',
            UPDATE_APPOINTMENT_TAG: '/tenants/{tenant_id}/class_appt_tags/{tag_id}'
        },
        APPOINTMENT_SUB_TYPE: {
            GET_APPOINTMENT_SUB_TYPES: '/tenants/{tenant_id}/appointment_types/{appt_type_id}/appt_subtypes'
        },
        CLASS_TYPE: {
            GET_CLASS_TYPES: '/tenants/{tenant_id}/class_types'
        },
        CLASS: {
            GET_CLASSES: '/tenants/{tenant_id}/classes',
            GET_CLASS: '/tenants/{tenant_id}/classes/{class_id}',
            GET_RECURRING_CLASS_TEMPLATE_ID: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}',
            GET_RECURRING_CLASS_TEMPLATE: '/tenants/{tenant_id}/recurring_classes',
            GET_RECURRING_CLASSES: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/classes',
            POST_CLASSES: '/tenants/{tenant_id}/classes',
            POST_RECURRING_CLASSES: '/tenants/{tenant_id}/recurring_classes',
            PUT_CLASS: '/tenants/{tenant_id}/classes/{class_id}',
            PUT_RECURRING_CLASS: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}',
            SUBSTITUTE_COACH: '/tenants/{tenant_id}/classes/{class_id}/substitute_coach',
            SUBSTITUTE_COACH_RECURRING: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/substitute_coach',
            RESCHEDULE_CLASS: '/tenants/{tenant_id}/classes/{class_id}/reschedule_class',
            RESCHEDULE_RECURRING_CLASS: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/reschedule_class',
            CANCEL_CLASS: '/tenants/{tenant_id}/classes/{class_id}/cancel_class',
            DELETE_CLASS: '/tenants/{tenant_id}/classes/{class_id}',
            CANCEL_CLASS_RECURRING_TEMPLATE: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}/cancel_class',
            DELETE_CLASS_RECURRING_TEMPLATE: '/tenants/{tenant_id}/recurring_classes/{class_recurring_template_id}',
            COMPLETE_CLASS: '/tenants/{tenant_id}/classes/{class_id}/mark_as_completed',
            MARK_CLASS_OPEN: '/tenants/{tenant_id}/classes/{class_id}/mark_as_open',
            GET_CLASS_CLIENT:"/tenants/{tenant_id}/clients/{client_id}/class_bookings",
            GET_CLASS_BOOKINGS_CLIENT_V2: '/v2/tenants/{tenant_id}/clients/{client_id}/class_bookings',
            GET_CLASS_BOOKING_DETAIL_V2: '/v2/tenants/{tenant_id}/clients/{client_id}/class_bookings/{booking_id}',
        },
        CLASS_BOOKING: {
            BOOK_CLIENTS_TO_CLASS: '/tenants/{tenant_id}/classes/{class_id}/book_client_to_class',
            REMOVE_CLIENTS_FROM_CLASS: '/tenants/{tenant_id}/classes/{class_id}/remove_client_from_class',
            MARK_CLIENT_NO_SHOW: '/tenants/{tenant_id}/classes/{class_id}/mark_client_noshow',
            MARK_CLIENT_CHECKEDIN: '/tenants/{tenant_id}/classes/{class_id}/mark_client_checkedin',
            UPDATE_CLASS_CLIENT_BOOKING: '/tenants/{tenant_id}/classes/{class_id}/change_client_membership',
            COMP_CLASS: '/tenants/{tenant_id}/clients/{client_id}/comp_class/{class_booking_id}',
            ADD_TRIAL_TO_CLASS: '/tenants/{tenant_id}/classes/{class_id}/add_trial_to_class',
        }
    },

    INVOICES: {
        GET_INVOICES: '/clients/{client_id}/invoices',
        GET_INVOICE_PDF: '/clients/{client_id}/invoices/{invoice_id}/pdf_invoice',
        VOID_INVOICE: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/void',
        SEND_EMAIL: '/clients/{client_id}/invoices/{invoice_id}/send_invoice_pdf',
        SALES_RETURN: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/sales_return',
        SALES_RETURN_CALCULATION: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/salesreturn_excessamount_calculation',
        VOID_SALES_RETURN: '/tenants/{tenant_id}/clients/{client_id}/salesreturn/{sales_return_id}/void',
        SEND_SALES_RETURN_PDF: '/clients/{client_id}/invoices/{invoice_id}/sales_return/{sales_return_id}/pdf_salesreturn_invoice',
        GET_SALES_RETURN_PDF: '/clients/{client_id}/invoices/{invoice_id}/sales_return/{sales_return_id}/pdf_salesreturn_invoice',
        GET_OPEN_SALES_RETURN_PDF: '/open/sales_return/{uuid}/pdf_sales_return',
        GET_AVAILABLE_ONLINE_REFUND: '/tenants/{tenant_id}/clients/{client_id}/AvailableOnlineRefund/{invoice_id}',
        GET_INVOICE_OPEN: '/open/invoices/{uuid}/pdf_invoice',
        CHANGE_SALES_REP: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/change_invoice_sales_rep',
        CHARGE_MANUAL_FAILED_PAYMENTS: '/tenants/{tenant_id}/clients/{client_id}/invoice/{invoice_id}/charge_manual_failed_payments',
        CREATE_WRITEOFF: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/writeoff',
        GET_WRITEOFF: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/writeoff',
        VOID_WRITEOFF: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/writeoff/{writeoff_id}/void'
    },
    PAYMENTS: {
        GET_PAYMENTS: '/clients/{client_id}/payments',
        GET_PAYMENT_PDF: '/clients/{client_id}/payments/{pymt_id}/pdf_payment',
        VOID_PAYMENT: '/tenants/{tenant_id}/clients/{client_id}/payments/{pymt_id}/void',
        MAKE_PAYMENT: '/tenants/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/payments',
        SEND_EMAIL: '/clients/{client_id}/payments/{pymt_id}/send_payment_pdf',
        GET_PAYMENT_BY_ID: '/clients/{client_id}/payments/{pymt_id}',
    },

    OPEN_API: {
        GET_COUNTRY: '/open/countries',
        GET_STATE: '/open/countries/{countrycode}/states',
        GET_CITY: '/open/countries/{countrycode}/states/{statecode}/cities',
        GET_PLANLIST: '/tenants/{tenant_id}/online_signup/subscription_plans',
        GET_COMPANYBYID: '/open/companies/{company_id}',
        GET_COMPANY_SUBDOMAIN: '/open/companies?subdomain={subdomain}',
        GET_TENANTBYID: '/open/tenants/{tenant_id}',
        GET_MANDATORYFIELDS: '/tenants/{tenant_id}/online_signup/mandatory_client_fields',
        PATCH_UPDATECLIENT: '/tenants/{tenant_id}/online_signup/clients',
        GET_PLAN_BY_ID: '/tenants/{tenant_id}/online_signup/subscription_plans/{plan_id}',
        UPDATE_SUBSCRIPTION_SIGNUP: '/subscription/signup/{sigup_sts_uuid}',
        PATCH_UPDATE_CLIENT_UUID: '/subscription/signup/{sigup_sts_uuid}/client_info',
    },

    FREEZE: {
        GET_AVAILABLEFORFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/available_for_freeze',
        GET_FREEZEBYCLIENTID: '/clients/{client_id}/freeze',
        GET_FREEZEBYSUBSCRIPTIONID: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze',
        GET_FREEZETIMELINE: '/clients/{client_id}/subscriptions/{clt_subs_id}/payment_timeline',
        POST_CREATEFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze',
        POST_CANCELFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{clt_subfreeze_id}/cancel_freeze',
        POST_STOPFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{clt_subfreeze_id}/stop_freeze',
        PUT_UPDATEFREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{clt_subfreeze_id}',
    },

    SUBSCRIPTION:{
        POST_CHANGE_SESSION_OWNER:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subs_id}/clt_memberships/{clt_membership_id}/change_session_owner",
        CANCEL_SUBSCRIPTION:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subs_id}/Cancel",
        EARLIEST_CANCELLATION_DATE_PREVIEW:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subs_id}/cancellation/earliest_date_preview",
        IMMEDIATE_RECENT_VALIDATE_DATE:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subs_id}/cancellation/immediate_recent_validate_date",
        CANCELLATION_REASONS:"/tenants/{tenant_id}/cancellation_reasons",
        ACTIVE_SUBSCRIPTION_MEMBERSHIP:"/clients/{client_id}/subscriptions/active_memberships",
        PUT_START_DATE_MEMBERSHIP:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/memberships/{client_membership_id}/change_start_date",
        PUT_END_DATE_MEMBERSHIP:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/memberships/{client_membership_id}/change_end_date",
        PUT_START_DATE_SUBSCRIPTION:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/change_start_date",
        PUT_END_DATE_SUBSCRIPTION:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/change_end_date",
        RECURRING_ACCURENCE_EXCEPTION:"/tenant/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/midcycle_addon_discount",
        ACTIVATE_SUBSCRIPTION:"/tenant/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/forcefully_mark_sub_signup_complete",
        RE_ACTIVATE_SUBSCRIPTION:"/tenant/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/reactivate",
        CHANGE_MEMBERSHIP_SESSIONS:"/tenants/{tenant_id}/clients/{client_id}/subscriptions/{client_subscription_id}/memberships/{client_membership_id}/client_membership_patch",
        VOID_SUBSCRIPTION: '/tenant/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/void',
        SEND_MANAGE_LINK: '/tenant/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/send_manage_link',
        GET_FAMILY_MEMBERS: '/tenants/{tenant_id}/subscription_plans/{subscription_plan_id}/clients',
        EDIT_TIMELINE_PRICING: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/recurring_billing_timeline/pricing',
        FORCEFULLY_STATUS_CHANGES: '/tenant/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/forcefully-status-changes',
        CLEAR_STATUS_OVERRIDE_BULK: '/tenant/{tenant_id}/subscriptions/clear-status-override',
        LIST_STATUS_OVERRIDES: '/tenants/{tenant_id}/subscriptions/status_override',
        LIST_STOPPED_BILLING: '/tenants/{tenant_id}/subscriptions/stopped_billing',
        LIST_ACTIVE_SUBSCRIPTIONS:'/tenants/{tenant_id}/subscriptions/active_subscriptions',
        EXPORT_ACTIVE_SUBSCRIPTIONS:'/tenants/{tenant_id}/subscriptions/active_subscriptions/export',
        EXPORT_STATUS_OVERRIDES: '/tenants/{tenant_id}/subscriptions/status_override/export',
        EXPORT_STOPPED_BILLING: '/tenants/{tenant_id}/subscriptions/stopped_billing/export',
    },
    
    CLIENT_TRIAL:{
        GET_TRIALS:"/clients/{client_id}/trials",
        GET_TRIAL:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}",
        POST_TRIAL:"/tenants/{tenant_id}/clients/{client_id}/trials",
        PUT_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}",
        DELETE_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}",
        POST_ACTIVATE_TRIALS:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}/activate",
        MARK_AS_ACTIVE:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}/mark_as_active",
        MARK_AS_IN_ACTIVE:"/tenants/{tenant_id}/clients/{client_id}/trials/{clt_trial_id}/mark_as_inactive",
    },

    WIDGETS:{
        GET_WIDGETS:"/companies/widgets",
        GET_WIDGET_BY_ID:"/companies/widgets/{widget_id}",
        CREATE_WIDGET:"/companies/widgets",
        UPDATE_WIDGET:"/companies/widgets/{widget_id}",
        DELETE_WIDGET:"/companies/widgets/{widget_id}",
        ACTIVATE_WIDGET:"/companies/widgets/{widget_id}/mark_as_active",
        INACTIVATE_WIDGET:"/companies/widgets/{widget_id}/mark_as_inactive",
    },

    GL_ACCOUNTS: {
        GET_GL_ACCOUNTS: '/tenants/{tenant_id}/gl_accounts',
        CREATE_GL_ACCOUNT: '/tenants/{tenant_id}/gl_accounts',
        GET_GL_ACCOUNT_BY_ID: '/tenants/{tenant_id}/gl_accounts/{gl_account_id}',
        UPDATE_GL_ACCOUNT: '/tenants/{tenant_id}/gl_accounts/{gl_account_id}',
        DELETE_GL_ACCOUNT: '/tenants/{tenant_id}/gl_accounts/{gl_account_id}',
        MARK_GL_ACCOUNT_ACTIVE: '/tenants/{tenant_id}/gl_accounts/{gl_account_id}/mark_as_active',
        MARK_GL_ACCOUNT_INACTIVE: '/tenants/{tenant_id}/gl_accounts/{gl_account_id}/mark_as_inactive'
    },

    GL_MAPPING_RULES: {
        GET_GL_MAPPING_RULES: '/tenants/{tenant_id}/gl_mapping_rules',
        CREATE_GL_MAPPING_RULE: '/tenants/{tenant_id}/gl_mapping_rules',
        GET_GL_MAPPING_RULE_BY_ID: '/tenants/{tenant_id}/gl_mapping_rules/{gl_map_id}',
        UPDATE_GL_MAPPING_RULE: '/tenants/{tenant_id}/gl_mapping_rules/{gl_map_id}',
        DELETE_GL_MAPPING_RULE: '/tenants/{tenant_id}/gl_mapping_rules/{gl_map_id}',
        MARK_GL_MAPPING_RULE_ACTIVE: '/tenants/{tenant_id}/gl_mapping_rules/{gl_map_id}/mark_as_active',
        MARK_GL_MAPPING_RULE_INACTIVE: '/tenants/{tenant_id}/gl_mapping_rules/{gl_map_id}/mark_as_inactive'
    },

    AUDIT_TRAIL: {
        SEARCH_AUDIT_TRAILS: '/audit_trails/search',
        GET_ENTITY_AUDIT_TRAIL: '/audit_trails/entity/{entity_type}',
        EXPORT_AUDIT_TRAILS: '/audit_trails/export'
    },

    PLAN_CHANGE_MANAGEMENT: {
        GET_PLAN_CHANGE_BATCHES: '/tenants/{tenant_id}/plan_change_batch',
        CREATE_PLAN_CHANGE_BATCH: '/tenants/{tenant_id}/plan_change_batch',
        GET_ACTIVE_SUBSCRIPTIONS_FOR_PLAN: '/tenants/{tenant_id}/plans/{plan_id}/active_subscriptions',
        CANCEL_PLAN_CHANGE_BATCH: '/tenants/{tenant_id}/plan_change_batch/{batch_id}/cancel',
        UPDATE_SUBSCRIPTION_PLAN: '/tenants/{tenant_id}/subscription_plans/{plan_id}'
    },

    FREEZE_MANAGEMENT: {
        GET_FREEZE_REASONS: '/tenants/{tenant_id}/freeze/reasons',
        CREATE_FREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/freeze',
        CREATE_FREEZE_REQUEST: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/freeze_request',
        GET_FREEZE_REQUESTS: '/tenants/{tenant_id}/freeze_request',
        GET_FREEZE_LIST: '/tenants/{tenant_id}/freeze',
        GET_FREEZE_REQUEST_BY_ID: '/tenants/{tenant_id}/freeze_request/{freeze_request_id}',
        UPDATE_STAFF_COMMENTS: '/tenants/{tenant_id}/freeze_request/{freeze_request_id}/staff_comments',
        APPROVE_FREEZE_REQUEST: '/tenants/{tenant_id}/freeze_request/{freeze_request_id}/approve',
        REJECT_FREEZE_REQUEST: '/tenants/{tenant_id}/freeze_request/{freeze_request_id}/reject',
        REQUIRE_MORE_INFO: '/tenants/{tenant_id}/freeze_request/{freeze_request_id}/require_more_info',
        CANCEL_FREEZE_REQUEST: '/tenants/{tenant_id}/freeze_request/{freeze_request_id}/cancel',
        COMP_FREEZE: '/tenants/{tenant_id}/freeze/{freeze_id}/comp',
        VERIFY_DOCUMENT: '/tenants/{tenant_id}/documents/{document_id}/verify',
        REJECT_DOCUMENT: '/tenants/{tenant_id}/documents/{document_id}/reject',
        GET_FREEZE_CHARGE_BREAKUP: '/tenants/{tenant_id}/subscriptions/{subscription_id}/freeze_breakup_calculation',
        CALCULATE_FREEZE_ADJUSTMENT: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/calculate_freeze_adjustment',
        RESCHEDULE_FREEZE: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{clt_subs_id}/freeze/{freeze_id}'
    },

    ANALYTICS: {
        GET_DAILY_TENANT_SUMMARY: '/analytics/daily_tenant_summary',
        GET_MONTHLY_CLIENT_SUMMARY: '/analytics/monthly_client_level_summary',
        GET_MONTHLY_PAYMENT_METHOD_SUMMARY: '/analytics/monthly_payment_method_summary',
        GET_MONTHLY_SERVICE_CATEGORY_SUMMARY: '/analytics/monthly_service_category_summary',
        GET_MONTHLY_STAFF_SUMMARY: '/analytics/monthly_staff_summary',
        GET_POPULAR_TIMES: '/tenants/{tenant_id}/popular-times'
    },

    PAYOUT_ENGINE: {
        // Rule Groups
        GET_RULE_GROUPS: '/api/rule-group',
        GET_RULE_GROUP_BY_ID: '/api/rule-group/{id}',
        CREATE_RULE_GROUP: '/api/rule-group',
        UPDATE_RULE_GROUP: '/api/rule-group/{id}',
        DELETE_RULE_GROUP: '/api/rule-group/{id}',
        DELETE_RULE_LAYER: '/api/rule-layer/{id}',
        REORDER_RULE_LAYER: '/api/rule-layer/{id}/reorder',
        
        // Rule Layers
        GET_RULE_LAYERS: '/api/rule-layer',
        GET_RULE_LAYERS_BY_RULE_GROUP: '/api/rule-layer/rule-group/{ruleGroupId}',
        GET_RULE_LAYER_BY_ID: '/api/rule-layer/{layer_id}',
        CREATE_RULE_LAYER: '/api/rule-layer',
        UPDATE_RULE_LAYER: '/api/rule-layer/{layer_id}',
        
        // Profiles
        GET_PAYOUT_PROFILES: '/api/profile',
        GET_PAYOUT_PROFILE_BY_ID: '/api/profile/{id}',
        CREATE_PAYOUT_PROFILE: '/api/profile',
        UPDATE_PAYOUT_PROFILE: '/api/profile/{id}',
        DELETE_PAYOUT_PROFILE: '/api/profile/{id}',
        ACTIVATE_PROFILE: '/api/profile/{id}/activate',
        DEACTIVATE_PROFILE: '/api/profile/{id}/deactivate',
        
        // Obligations
        GET_PAYOUT_OBLIGATIONS: '/api/obligation',
        GET_PAYOUT_OBLIGATION_BY_ID: '/api/obligation/{id}',
        CREATE_MANUAL_FEE: '/api/payout/manual-fee',
        GET_OBLIGATION_SETTLEMENTS: '/api/obligation/{obligation_id}/settlements',
        GET_OBLIGATION_ADJUSTMENTS: '/api/obligation/{obligation_id}/adjustments',
        CREATE_OBLIGATION_ADJUSTMENT: '/api/obligation/{id}/adjust',
        WRITE_OFF_OBLIGATION: '/api/payout/write-off',
        GET_OBLIGATIONS_SUMMARY: '/api/payout/obligations/summary',
        
        // Cycles
        GET_PAYOUT_CYCLES: '/api/cycle',
        GET_PAYOUT_CYCLE_BY_ID: '/api/cycle/{id}',
        UPDATE_DRAFT_CYCLE: '/api/cycle/{id}/draft',
        GET_CYCLES_SUMMARY: '/api/payout/cycles/summary',
        
        // Payout Providers
        GET_PAYOUT_PROVIDERS: '/api/provider',
        GET_PAYOUT_PROVIDER_BY_ID: '/api/provider/{id}',
        CREATE_PAYOUT_PROVIDER: '/api/provider',
        UPDATE_PAYOUT_PROVIDER: '/api/provider/{id}',
        DELETE_PAYOUT_PROVIDER: '/api/provider/{id}',
        
        // Tenant Provider Mapping
        GET_TENANT_PROVIDER_MAPPINGS: '/api/TenantProviderMapping',
        GET_TENANT_PROVIDER_MAPPING_BY_ID: '/api/TenantProviderMapping/{id}',
        CREATE_TENANT_PROVIDER_MAPPING: '/api/TenantProviderMapping',
        UPDATE_TENANT_PROVIDER_MAPPING: '/api/TenantProviderMapping/{id}',
        DELETE_TENANT_PROVIDER_MAPPING: '/api/TenantProviderMapping/{id}',
        ACTIVATE_TENANT_PROVIDER_MAPPING: '/api/TenantProviderMapping/{id}/activate',
        DEACTIVATE_TENANT_PROVIDER_MAPPING: '/api/TenantProviderMapping/{id}/deactivate',
        GET_TENANT_PROVIDER_MAPPING_BY_TENANT: '/api/TenantProviderMapping/tenant/{tenant_id}',
        GET_ACTIVE_TENANT_PROVIDER_MAPPING: '/api/TenantProviderMapping/tenant/{tenant_id}/active',
        GET_PROVIDER_MAPPING_BY_COMPANY: '/api/TenantProviderMapping/company'
    },
    
    // Commission Management
    COMMISSION: {
        // Commission Plans - Company Level
        GET_COMPANY_COMMISSION_PLANS: '/companies/commission-plans',
        GET_COMPANY_COMMISSION_PLAN_BY_ID: '/companies/commission-plans/{plan_id}',
        CREATE_COMPANY_COMMISSION_PLAN: '/companies/commission-plans',
        UPDATE_COMPANY_COMMISSION_PLAN: '/companies/commission-plans/{plan_id}',
        DELETE_COMPANY_COMMISSION_PLAN: '/companies/commission-plans/{plan_id}',
        
        // Commission Plans - Franchise Group Level
        GET_FRANCHISE_GROUP_COMMISSION_PLANS: '/franchise_group/{franchise_group_id}/commission-plans',
        GET_FRANCHISE_GROUP_COMMISSION_PLAN_BY_ID: '/franchise_group/{franchise_group_id}/commission-plans/{plan_id}',
        CREATE_FRANCHISE_GROUP_COMMISSION_PLAN: '/franchise_group/{franchise_group_id}/commission-plans',
        UPDATE_FRANCHISE_GROUP_COMMISSION_PLAN: '/franchise_group/{franchise_group_id}/commission-plans/{plan_id}',
        DELETE_FRANCHISE_GROUP_COMMISSION_PLAN: '/franchise_group/{franchise_group_id}/commission-plans/{plan_id}',
        
        // Commission Plans - Tenant Level
        GET_TENANT_COMMISSION_PLANS: '/tenants/{tenant_id}/commission-plans',
        GET_TENANT_COMMISSION_PLAN_BY_ID: '/tenants/{tenant_id}/commission-plans/{plan_id}',
        CREATE_TENANT_COMMISSION_PLAN: '/tenants/{tenant_id}/commission-plans',
        UPDATE_TENANT_COMMISSION_PLAN: '/tenants/{tenant_id}/commission-plans/{plan_id}',
        DELETE_TENANT_COMMISSION_PLAN: '/tenants/{tenant_id}/commission-plans/{plan_id}',
        
        // Staff Assignments
        ASSIGN_STAFF_TO_PLAN: '/tenants/{tenant_id}/commission-plans/{plan_id}/staff-assignments',
        GET_PLAN_STAFF_ASSIGNMENTS: '/tenants/{tenant_id}/commission-plans/{plan_id}/staff-assignments',
        REMOVE_STAFF_FROM_PLAN: '/tenants/{tenant_id}/commission-plans/{plan_id}/staff-assignments/{staff_id}',
        GET_STAFF_PLAN_ASSIGNMENTS: '/tenants/{tenant_id}/staff/{staff_id}/commission-plan-assignments',
        ASSIGN_PLAN_TO_STAFF: '/tenants/{tenant_id}/staff/{staff_id}/commission-plan-assignments',
        
        // Commission Plan Slabs - Company Level (nested under rules)
        GET_COMPANY_PLAN_RULE_SLABS: '/companies/commission-plans/{plan_id}/rules/{rule_id}/slabs',
        GET_COMPANY_PLAN_RULE_SLAB_BY_ID: '/companies/commission-plans/{plan_id}/rules/{rule_id}/slabs/{slab_id}',
        CREATE_COMPANY_PLAN_RULE_SLAB: '/companies/commission-plans/{plan_id}/rules/{rule_id}/slabs',
        UPDATE_COMPANY_PLAN_RULE_SLAB: '/companies/commission-plans/{plan_id}/rules/{rule_id}/slabs/{slab_id}',
        DELETE_COMPANY_PLAN_RULE_SLAB: '/companies/commission-plans/{plan_id}/rules/{rule_id}/slabs/{slab_id}',
        
        // Commission Plan Slabs - Tenant Level
        GET_PLAN_SLABS: '/tenants/{tenant_id}/commission-plans/{plan_id}/slabs',
        GET_PLAN_SLAB_BY_ID: '/tenants/{tenant_id}/commission-plans/{plan_id}/slabs/{slab_id}',
        CREATE_PLAN_SLAB: '/tenants/{tenant_id}/commission-plans/{plan_id}/slabs',
        UPDATE_PLAN_SLAB: '/tenants/{tenant_id}/commission-plans/{plan_id}/slabs/{slab_id}',
        DELETE_PLAN_SLAB: '/tenants/{tenant_id}/commission-plans/{plan_id}/slabs/{slab_id}',
        
        // Commission Plan Rules - Company Level
        GET_COMPANY_PLAN_RULES: '/companies/commission-plans/{plan_id}/rules',
        GET_COMPANY_PLAN_RULE_BY_ID: '/companies/commission-plans/{plan_id}/rules/{rule_id}',
        CREATE_COMPANY_PLAN_RULE: '/companies/commission-plans/{plan_id}/rules',
        UPDATE_COMPANY_PLAN_RULE: '/companies/commission-plans/{plan_id}/rules/{rule_id}',
        DELETE_COMPANY_PLAN_RULE: '/companies/commission-plans/{plan_id}/rules/{rule_id}',
        
        // Commission Plan Rules - Tenant Level
        GET_PLAN_RULES: '/tenants/{tenant_id}/commission-plans/{plan_id}/rules',
        GET_PLAN_RULE_BY_ID: '/tenants/{tenant_id}/commission-plans/{plan_id}/rules/{rule_id}',
        CREATE_PLAN_RULE: '/tenants/{tenant_id}/commission-plans/{plan_id}/rules',
        UPDATE_PLAN_RULE: '/tenants/{tenant_id}/commission-plans/{plan_id}/rules/{rule_id}',
        DELETE_PLAN_RULE: '/tenants/{tenant_id}/commission-plans/{plan_id}/rules/{rule_id}',
        
        // Staff Commissions
        GET_STAFF_COMMISSIONS: '/tenants/{tenant_id}/staff/{staff_id}/commissions',
        GET_STAFF_COMMISSION_BY_ID: '/tenants/{tenant_id}/staff/{staff_id}/commissions/{commission_id}',
        GET_STAFF_COMMISSION_SUMMARY: '/tenants/{tenant_id}/staff/{staff_id}/commission-summary',
        
        // Staff Commissions - Current User
        GET_CURRENT_USER_COMMISSIONS: '/me/commissions/current-period',
        
        // Staff Plan Assignments - Company/Tenant Level
        GET_COMPANY_TENANT_STAFF_PLAN_ASSIGNMENTS: '/companies/tenants/{tenant_id}/staff/plan-assignments',

        GET_COMMISSION_TRANSACTIONS: '/tenants/{tenant_id}/commissions/transactions',
        CREATE_STAFF_COMMISSION_ADJUSTMENTS: '/tenants/{tenant_id}/commissions/adjustments',
        MARK_COMMISSIONS_AS_PROCESSED: '/tenants/{tenant_id}/commissions/mark_as_processed',
        GET_COMMISSION_PROCESSED_BY_ID: '/CommissionProcessed/{processed_id}',
    },
    
    // Staff Availability
    STAFF_AVAILABILITY: {
        // Staff Availability Config
        GET_STAFF_AVAILABILITY_CONFIG: '/tenants/{tenant_id}/staff/{staff_id}/availablity_config',
        CREATE_STAFF_AVAILABILITY_CONFIG: '/tenants/{tenant_id}/staff/{staff_id}/availablity_config',
        UPDATE_STAFF_AVAILABILITY_CONFIG: '/tenants/{tenant_id}/staff/{staff_id}/availablity_config/{schedule_group_id}',
        
        // Staff Appointment Type Links
        GET_STAFF_APPOINTMENT_TYPE_LINKS: '/tenants/{tenant_id}/staff/{staff_id}/assigned_appointment_types',
        GET_ASSIGNED_STAFFS_BY_APPOINTMENT_CATEGORY: '/tenants/{tenant_id}/appointments/{appointment_category_id}/assigned_staffs',
        
        // Staff Availability Checks
        CHECK_STAFF_AVAILABILITY_FOR_CLASS: '/tenants/{tenant_id}/staff/{staff_id}/check_availablity',
        CHECK_STAFF_AVAILABILITY_FOR_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appointment_id}/staff/{staff_id}/check_availablity',
        CHECK_STAFF_AVAILABILITY_FOR_RECURRING_CLASS: '/tenants/{tenant_id}/staff/{staff_id}/check_recurring_availablity',
        CHECK_STAFF_AVAILABILITY_FOR_RECURRING_APPOINTMENT: '/tenants/{tenant_id}/appointments/{appointment_id}/staff/{staff_id}/check_recurring_availablity'
    },
    
    // Client Transfer
    CLIENT_TRANSFER: {
        // L2L Transfer Initiation
        CREATE_L2L_TRANSFER_INITIATION: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/l2l_transfer_initiation',
        CREATE_C2C_TRANSFER_INITIATION: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/c2c_transfer_initiation',
        
        // Transfer List and Details
        GET_TRANSFER_LIST: '/tenants/{tenant_id}/ListTransfer',
        GET_TRANSFER_BY_ID: '/tenants/{tenant_id}/transfer/{transfer_id}',
        
        // Transfer Calculations
        TRANSFER_BREAKDOWN_CALCULATION: '/tenants/{tenant_id}/subscription_plans/{subscription_plan_id}/plan_breakup_calculation',
        L2L_TRANSFER_CALCULATION: '/tenants/{tenant_id}/clients/{client_id}/transfer/{transfer_id}/l2l_transfer_calculation',
        L2L_TRANSFER_RE_CALCULATION: '/tenants/{tenant_id}/clients/{client_id}/transfer/{transfer_id}/l2l_transfer_re_calculate',
        L2L_TRANSFER_INITIATION_BY_PLAN: '/tenants/{tenant_id}/subscription_plans/{subscription_plan_id}/l2l_transfer_initiation',
        L2L_TRANSFER: '/tenants/{tenant_id}/clients/{client_id}/transfer/{transfer_id}/l2l_transfer',
        
        // Transfer Status
        UPDATE_TRANSFER_STATUS: '/tenants/{tenant_id}/transfer/{transfer_id}/{status}',
        
        // Transfer Validation
        C2C_TRANSFER_VALIDATION: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/c2c_transfer_validation'
    },
    
    // Sponser/Corporate
    SPONSER: {
        GET_SPONSORS: '/tenants/{tenant_id}/corporate',
        GET_SPONSOR_BY_ID: '/tenants/{tenant_id}/corporate/{sponsor_id}',
        GET_TENANT_SPONSOR_CONTRACTS: '/tenants/{tenant_id}/sponsorContracts',
        GET_COMPANY_SPONSOR_CONTRACTS: '/companies/sponsorContracts'
    },
    
    // Retail Billing
    RETAIL: {
        // Products - Company Level
        GET_COMPANY_PRODUCTS: '/companies/retail_products',
        GET_COMPANY_PRODUCT_BY_ID: '/companies/retail_products/{product_id}',
        CREATE_COMPANY_PRODUCT: '/companies/retail_products',
        UPDATE_COMPANY_PRODUCT: '/companies/retail_products/{product_id}',
        DELETE_COMPANY_PRODUCT: '/companies/retail_products/{product_id}',
        GET_PRODUCTS_BY_IDS: '/companies/retail_products/by-ids',
        
        // Products - Tenant Level
        GET_TENANT_PRODUCTS: '/tenants/{tenant_id}/retail_products',
        GET_TENANT_PRODUCT_BY_ID: '/tenants/{tenant_id}/retail_products/{product_id}',
        CREATE_TENANT_PRODUCT: '/tenants/{tenant_id}/retail_products',
        UPDATE_TENANT_PRODUCT: '/tenants/{tenant_id}/retail_products/{product_id}',
        DELETE_TENANT_PRODUCT: '/tenants/{tenant_id}/retail_products/{product_id}',
        
        // Product SKUs
        GET_PRODUCT_SKUS: '/companies/retail_products/{product_id}/skus',
        GET_PRODUCT_SKU_BY_ID: '/companies/retail_products/{product_id}/skus/{sku_id}',
        CREATE_PRODUCT_SKU: '/companies/retail_products/{product_id}/skus',
        UPDATE_PRODUCT_SKU: '/companies/retail_products/{product_id}/skus/{sku_id}',
        DELETE_PRODUCT_SKU: '/companies/retail_products/{product_id}/skus/{sku_id}',
        
        // Product Categories
        GET_PRODUCT_CATEGORIES: '/companies/product-categories',
        GET_PRODUCT_CATEGORY_BY_ID: '/companies/product-categories/{category_id}',
        CREATE_PRODUCT_CATEGORY: '/companies/product-categories',
        UPDATE_PRODUCT_CATEGORY: '/companies/product-categories/{category_id}',
        DELETE_PRODUCT_CATEGORY: '/companies/product-categories/{category_id}',
        
        // Brands
        GET_BRANDS: '/companies/brands',
        GET_BRAND_BY_ID: '/companies/brands/{brand_id}',
        CREATE_BRAND: '/companies/brands',
        UPDATE_BRAND: '/companies/brands/{brand_id}',
        DELETE_BRAND: '/companies/brands/{brand_id}',

        // Suppliers
        GET_SUPPLIERS: '/companies/suppliers',
        GET_SUPPLIER_BY_ID: '/companies/suppliers/{supplier_id}',
        CREATE_SUPPLIER: '/companies/suppliers',
        UPDATE_SUPPLIER: '/companies/suppliers/{supplier_id}',
        
        // Retail API (General)
        GET_RETAIL_PRODUCTS: '/tenants/{tenant_id}/retail_products',
        GET_RETAIL_PRODUCT_BY_ID: '/tenants/{tenant_id}/retail_products/{product_id}',
        
        // Inventory
        GET_INVENTORY_ITEMS: '/tenants/{tenant_id}/retail_products/skus/inventory',
        CREATE_INVENTORY_MOVEMENTS: '/tenants/{tenant_id}/retail_products/skus/inventory',
        SEARCH_SKU_BY_BARCODE: '/tenants/{tenant_id}/retail_products/skus/{barcode}',
        SEARCH_SKUS: '/tenants/{tenant_id}/retail_products/skus',
        
        // Legacy Product APIs (for backward compatibility)
        GET_LEGACY_TENANT_PRODUCT: '/tenants/{tenant_id}/products/{product_id}',
        GET_PRODUCTS_FOR_PLAN: '/tenants/{tenant_id}/products/get-for-plan',
        
        // Tenant-Level Product SKU Operations
        GET_TENANT_PRODUCT_SKUS: '/tenants/{tenant_id}/retail_products/{product_id}/skus',
        GET_TENANT_PRODUCT_SKU_BY_ID: '/tenants/{tenant_id}/retail_products/{product_id}/skus/{sku_id}',
        CREATE_TENANT_PRODUCT_SKUS: '/tenants/{tenant_id}/retail_products/{product_id}/skus',
        UPDATE_TENANT_PRODUCT_SKU: '/tenants/{tenant_id}/retail_products/{product_id}/skus/{sku_id}',
        
        // Tenant SKU with Inventory
        GET_TENANT_SKU_WITH_INVENTORY: '/tenants/{tenant_id}/retail_products/skus/{sku_id}',
        GET_TENANT_SKUS_WITH_INVENTORY: '/tenants/{tenant_id}/retail_products/skus',
        
        // Legacy SKU APIs (for backward compatibility)
        GET_LEGACY_PRODUCT_SKUS: '/tenants/{tenant_id}/products/{product_id}/skus',
        GET_LEGACY_PRODUCT_SKU_BY_ID: '/tenants/{tenant_id}/products/{product_id}/skus/{sku_id}',
        CREATE_LEGACY_PRODUCT_SKU: '/tenants/{tenant_id}/products/{product_id}/skus',
        UPDATE_LEGACY_PRODUCT_SKU: '/tenants/{tenant_id}/products/{product_id}/skus/{sku_id}'
    },
    
    // Notifications
    NOTIFICATIONS: {
        // Notification Templates
        GET_NOTIFICATIONS: '/tenants/{tenant_id}/notifications',
        
        // Email Templates
        GET_EMAIL_TEMPLATES: '/tenants/{tenant_id}/email_template_master',
        GET_EMAIL_TEMPLATE_BY_ID: '/tenants/{tenant_id}/email_template_master/{template_id}',
        CREATE_EMAIL_TEMPLATE: '/tenants/{tenant_id}/email_template_master',
        UPDATE_EMAIL_TEMPLATE: '/tenants/{tenant_id}/email_template_master/{template_id}',
        MARK_EMAIL_TEMPLATE_ACTIVE: '/tenants/{tenant_id}/email_template_master/{template_id}/mark_as_active',
        MARK_EMAIL_TEMPLATE_INACTIVE: '/tenants/{tenant_id}/email_template_master/{template_id}/mark_as_inactive',
        
        // User Upload Images - Company Level
        GET_COMPANY_USER_UPLOAD_IMAGES: '/companies/email_template_master/user_upload_images',
        UPLOAD_COMPANY_USER_IMAGE: '/companies/email_template_master/user_upload_images',
        
        // User Upload Images - Franchise Group Level
        GET_FRANCHISE_USER_UPLOAD_IMAGES: '/franchise_group/{franchise_group_id}/email_template_master/user_upload_images',
        UPLOAD_FRANCHISE_USER_IMAGE: '/franchise_group/{franchise_group_id}/email_template_master/user_upload_images',
        
        // User Upload Images - Tenant Level
        GET_USER_UPLOAD_IMAGES: '/tenants/{tenant_id}/email_template_master/user_upload_images',
        UPLOAD_USER_IMAGE: '/tenants/{tenant_id}/email_template_master/user_upload_images',
        
        // SMS Templates
        GET_SMS_TEMPLATES: '/tenants/{tenant_id}/sms_template_master',
        GET_SMS_TEMPLATE_BY_ID: '/tenants/{tenant_id}/sms_template_master/{template_id}',
        CREATE_SMS_TEMPLATE: '/tenants/{tenant_id}/sms_template_master',
        UPDATE_SMS_TEMPLATE: '/tenants/{tenant_id}/sms_template_master/{template_id}',
        MARK_SMS_TEMPLATE_ACTIVE: '/tenants/{tenant_id}/sms_template_master/{template_id}/mark_as_active',
        MARK_SMS_TEMPLATE_INACTIVE: '/tenants/{tenant_id}/sms_template_master/{template_id}/mark_as_inactive',
        
      // WhatsApp Templates - Company Level
      GET_COMPANY_WHATSAPP_TEMPLATES: '/companies/whatsapp_template_master',
      GET_COMPANY_WHATSAPP_TEMPLATE_BY_ID: '/companies/whatsapp_template_master/{template_id}',
      CREATE_COMPANY_WHATSAPP_TEMPLATE: '/companies/whatsapp_template_master',
      UPDATE_COMPANY_WHATSAPP_TEMPLATE: '/companies/whatsapp_template_master/{template_id}',
      MARK_COMPANY_WHATSAPP_TEMPLATE_ACTIVE: '/companies/whatsapp_template_master/{template_id}/mark_as_active',
      MARK_COMPANY_WHATSAPP_TEMPLATE_INACTIVE: '/companies/whatsapp_template_master/{template_id}/mark_as_inactive',
      
      // WhatsApp Templates - Franchise Group Level
      GET_FRANCHISE_WHATSAPP_TEMPLATES: '/franchise_group/{franchise_group_id}/whatsapp_template_master',
      GET_FRANCHISE_WHATSAPP_TEMPLATE_BY_ID: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}',
      CREATE_FRANCHISE_WHATSAPP_TEMPLATE: '/franchise_group/{franchise_group_id}/whatsapp_template_master',
      UPDATE_FRANCHISE_WHATSAPP_TEMPLATE: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}',
      MARK_FRANCHISE_WHATSAPP_TEMPLATE_ACTIVE: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}/mark_as_active',
      MARK_FRANCHISE_WHATSAPP_TEMPLATE_INACTIVE: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}/mark_as_inactive',
      
      // WhatsApp Templates - Tenant Level
      GET_WHATSAPP_TEMPLATES: '/tenants/{tenant_id}/whatsapp_template_master',
      GET_WHATSAPP_TEMPLATE_BY_ID: '/tenants/{tenant_id}/whatsapp_template_master/{template_id}',
      CREATE_WHATSAPP_TEMPLATE: '/tenants/{tenant_id}/whatsapp_template_master',
      UPDATE_WHATSAPP_TEMPLATE: '/tenants/{tenant_id}/whatsapp_template_master/{template_id}',
      MARK_WHATSAPP_TEMPLATE_ACTIVE: '/tenants/{tenant_id}/whatsapp_template_master/{template_id}/mark_as_active',
      MARK_WHATSAPP_TEMPLATE_INACTIVE: '/tenants/{tenant_id}/whatsapp_template_master/{template_id}/mark_as_inactive',
      
      // WhatsApp Template by Notification (legacy)
      GET_WHATSAPP_TEMPLATE_BY_NOTIFICATION: '/tenants/{tenant_id}/notifications/{notification_id}/whatsapp_template_master/{template_id}',
        
        // Push Notification Templates
        GET_PUSH_NOTIFICATION_TEMPLATES: '/tenants/{tenant_id}/push_notification_template_master',
        GET_PUSH_NOTIFICATION_TEMPLATE_BY_ID: '/tenants/{tenant_id}/push_notification_template_master/{template_id}',
        CREATE_PUSH_NOTIFICATION_TEMPLATE: '/tenants/{tenant_id}/push_notification_template_master',
        UPDATE_PUSH_NOTIFICATION_TEMPLATE: '/tenants/{tenant_id}/push_notification_template_master/{template_id}',
        DELETE_PUSH_NOTIFICATION_TEMPLATE: '/tenants/{tenant_id}/push_notification_template_master/{template_id}',
        MARK_PUSH_NOTIFICATION_TEMPLATE_ACTIVE: '/tenants/{tenant_id}/push_notification_template_master/{template_id}/mark_as_active',
        MARK_PUSH_NOTIFICATION_TEMPLATE_INACTIVE: '/tenants/{tenant_id}/push_notification_template_master/{template_id}/mark_as_inactive',
        
        // Email Configuration
        GET_EMAIL_FROM_CONFIG: '/tenants/{tenant_id}/email_from_config_master',
        GET_EMAIL_FROM_CONFIG_BY_ID: '/tenants/{tenant_id}/email_from_config_master/{from_email_id}',
        CREATE_EMAIL_FROM_CONFIG: '/tenants/{tenant_id}/email_provider_config_master/{email_provider_config_master}/email_from_config_master',
        UPDATE_EMAIL_FROM_CONFIG: '/tenants/{tenant_id}/email_provider_config_master/{email_provider_config_master}/email_from_config_master/{email_from_id}',
        MARK_EMAIL_FROM_ACTIVE: '/tenants/{tenant_id}/email_provider_config_master_id/{email_provider}/email_from_config_master/{email_from}/mark_as_active',
        MARK_EMAIL_FROM_INACTIVE: '/tenants/{tenant_id}/email_provider_config_master_id/{email_provider}/email_from_config_master/{email_from}/mark_as_inactive',
        
        // Email Provider Configuration
        GET_EMAIL_PROVIDER_CONFIG: '/tenants/{tenant_id}/email_provider_config_master',
        
        // SMS Configuration - Company Level
        GET_COMPANY_SMS_SENDER_CONFIG: '/companies/sms_sender_config_master',
        CREATE_COMPANY_SMS_SENDER_CONFIG: '/companies/sms_sender_config_master',
        UPDATE_COMPANY_SMS_SENDER_CONFIG: '/companies/sms_sender_config_master',
        MARK_COMPANY_SMS_SENDER_ACTIVE: '/companies/sms_sender_config_master/{config_id}/mark_as_active',
        MARK_COMPANY_SMS_SENDER_INACTIVE: '/companies/sms_sender_config_master/{config_id}/mark_as_inactive',
        
        // SMS Configuration - Franchise Group Level
        GET_FRANCHISE_SMS_SENDER_CONFIG: '/franchise_group/{franchise_group_id}/sms_sender_config_master',
        CREATE_FRANCHISE_SMS_SENDER_CONFIG: '/franchise_group/{franchise_group_id}/sms_sender_config_master',
        UPDATE_FRANCHISE_SMS_SENDER_CONFIG: '/franchise_group/{franchise_group_id}/sms_sender_config_master',
        MARK_FRANCHISE_SMS_SENDER_ACTIVE: '/franchise_group/{franchise_group_id}/sms_sender_config_master/{config_id}/mark_as_active',
        MARK_FRANCHISE_SMS_SENDER_INACTIVE: '/franchise_group/{franchise_group_id}/sms_sender_config_master/{config_id}/mark_as_inactive',
        
        // SMS Configuration - Tenant Level
        GET_SMS_SENDER_CONFIG: '/tenants/{tenant_id}/sms_sender_config_master',
        CREATE_SMS_SENDER_CONFIG: '/tenants/{tenant_id}/sms_sender_config_master',
        UPDATE_SMS_SENDER_CONFIG: '/tenants/{tenant_id}/sms_sender_config_master',
        MARK_SMS_SENDER_ACTIVE: '/tenants/{tenant_id}/sms_sender_config_master/{config_id}/mark_as_active',
        MARK_SMS_SENDER_INACTIVE: '/tenants/{tenant_id}/sms_sender_config_master/{config_id}/mark_as_inactive',
        
        // WhatsApp Configuration
        GET_WHATSAPP_CONFIG: '/tenants/{tenant_id}/whatsapp_config_master',
        
        // Send Messages
        SEND_FREE_FORM_SMS: '/tenants/{tenant_id}/clients/{client_id}/send_free_form_sms',
        SEND_TEMPLATED_SMS: '/tenants/{tenant_id}/clients/send_templated_sms',
        SEND_FREE_FORM_EMAIL: '/tenants/{tenant_id}/clients/{client_id}/send_free_form_email',
        SEND_TEMPLATED_EMAIL: '/tenants/{tenant_id}/clients/send_templated_email',
        SEND_FREE_FORM_WHATSAPP: '/tenants/{tenant_id}/clients/{client_id}/send_free_form_whatsapp',
        SEND_TEMPLATED_WHATSAPP: '/tenants/{tenant_id}/clients/send_templated_whatsapp',
        
        // Client Threads
        GET_CLIENT_THREADS: '/tenants/{tenant_id}/threads',
        
        // Mark as Read/Unread
        MARK_EMAIL_AS_READ: '/tenants/{tenant_id}/clients/{client_id}/email/threads/{thread_id}/messages/{interaction_id}/mark_as_read',
        MARK_SMS_AS_READ: '/tenants/{tenant_id}/clients/{client_id}/sms/messages/{interaction_id}/mark_as_read',
        MARK_WHATSAPP_AS_READ: '/tenants/{tenant_id}/clients/{client_id}/whatsapp/messages/{interaction_id}/mark_as_read',
        MARK_SMS_AS_UNREAD: '/tenants/{tenant_id}/clients/{client_id}/sms/messages/{interaction_id}/mark_as_unread',
        MARK_WHATSAPP_AS_UNREAD: '/tenants/{tenant_id}/clients/{client_id}/whatsapp/{thread_id}/messages/{interaction_id}/mark_as_unread',
        MARK_EMAIL_AS_UNREAD: '/tenants/{tenant_id}/clients/{client_id}/email/{thread_id}/messages/{interaction_id}/mark_as_unread',
        
      // Legacy/TODO - Fix with real API when available
      UPDATE_EMAIL_FROM_LEGACY: '/tenants/{tenant_id}/service_categories/{from_id}'
  },

  COUPONS: {
      // Coupon Master Operations
      CREATE_COUPON: '/tenants/{tenant_id}/offer_master',
      GET_COUPONS: '/tenants/{tenant_id}/offer_master',
      GET_COUPON_BY_ID: '/tenants/{tenant_id}/offer_master/{coupon_id}',
      UPDATE_COUPON: '/tenants/{tenant_id}/offer_master/{coupon_id}',
      MARK_OFFER_ACTIVE: '/tenants/{tenant_id}/offer_master/{coupon_id}/mark_as_active',
      MARK_OFFER_INACTIVE: '/tenants/{tenant_id}/offer_master/{coupon_id}/mark_as_inactive',
      
      // Coupon Codes
      GET_COUPON_CODES: '/tenants/{tenant_id}/offer_master/{coupon_id}/coupons',
      GENERATE_COUPON_CODES: '/tenants/{tenant_id}/offer_master/{coupon_id}/coupons',
      UPDATE_COUPON_CODE_LINK: '/tenants/{tenant_id}/offer_master/{coupon_id}/coupons/{coupon_link_id}',
      MARK_COUPON_CODE_ACTIVE: '/tenants/{tenant_id}/offer_master/{coupon_id}/coupons/{coupon_link_id}/mark_as_active',
      MARK_COUPON_CODE_INACTIVE: '/tenants/{tenant_id}/offer_master/{coupon_id}/coupons/{coupon_link_id}/mark_as_inactive',
      
      // Eligible Clients
      GET_ELIGIBLE_CLIENTS: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_clients',
      ADD_ELIGIBLE_CLIENTS: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_clients',
      REMOVE_ELIGIBLE_CLIENT: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_clients/{client_link_id}',
      
      // Eligible Services/Plans/Products
      GET_ELIGIBLE_SERVICES: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_services_plans_products',
      ADD_ELIGIBLE_SERVICE: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_services_plans_products',
      REMOVE_ELIGIBLE_SERVICE: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_services_plans_products/{service_link_id}',
      
      // Eligible Organizations
      GET_ELIGIBLE_ORGANIZATIONS: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_organisation',
      ADD_ELIGIBLE_ORGANIZATION: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_organisation',
      REMOVE_ELIGIBLE_ORGANIZATION: '/tenants/{tenant_id}/offer_master/{coupon_id}/eligible_organisation/{org_link_id}',
      
      // Plan Coupons
      GET_PLAN_ELIGIBLE_COUPONS: '/tenants/{tenant_id}/plans/{plan_id}/coupons'
  },

  CHARGE_MASTER: {
      // Charge Masters
      GET_CHARGE_MASTERS: '/tenants/{tenant_id}/charge_masters',
      GET_CHARGE_MASTER_BY_ID: '/tenants/{tenant_id}/charge_masters/{charge_master_id}',
      CREATE_CHARGE_MASTER: '/tenants/{tenant_id}/charge_masters',
      UPDATE_CHARGE_MASTER: '/tenants/{tenant_id}/charge_masters/{charge_master_id}',
      DELETE_CHARGE_MASTER: '/tenants/{tenant_id}/charge_masters/{charge_master_id}',
      MARK_CHARGE_MASTER_ACTIVE: '/tenants/{tenant_id}/charge_masters/{charge_master_id}/mark_as_active',
      MARK_CHARGE_MASTER_INACTIVE: '/tenants/{tenant_id}/charge_masters/{charge_master_id}/mark_as_inactive',
      
      // Charge Category Masters
      GET_CHARGE_CATEGORY_MASTERS: '/tenants/{tenant_id}/charge_category_master',
      GET_CHARGE_CATEGORY_MASTER_BY_ID: '/tenants/{tenant_id}/charge_category_master/{charge_category_master_id}',
      CREATE_CHARGE_CATEGORY_MASTER: '/tenants/{tenant_id}/charge_category_master',
      UPDATE_CHARGE_CATEGORY_MASTER: '/tenants/{tenant_id}/charge_category_master/{charge_category_master_id}',
      DELETE_CHARGE_CATEGORY_MASTER: '/tenants/{tenant_id}/charge_category_master/{charge_category_master_id}',
      MARK_CHARGE_CATEGORY_MASTER_ACTIVE: '/tenants/{tenant_id}/charge_category_master/{charge_category_master_id}/mark_as_active',
      MARK_CHARGE_CATEGORY_MASTER_INACTIVE: '/tenants/{tenant_id}/charge_category_master/{charge_category_master_id}/mark_as_inactive'
  },

  DASHBOARD: {
      GET_DASHBOARD_LAYOUT: '/tenants/{tenant_id}/dashboard_layout',
      SAVE_DASHBOARD_LAYOUT: '/tenants/{tenant_id}/dashboard_layout'
  },

  SERVICE_CATEGORY: {
      GET_SERVICE_CATEGORIES: '/tenants/{tenant_id}/service_categories',
      GET_SERVICE_CATEGORY_BY_ID: '/tenants/{tenant_id}/service_categories/{category_id}',
      CREATE_SERVICE_CATEGORY: '/tenants/{tenant_id}/service_categories',
      UPDATE_SERVICE_CATEGORY: '/tenants/{tenant_id}/service_categories/{category_id}',
      MARK_SERVICE_CATEGORY_ACTIVE: '/tenants/{tenant_id}/service_categories/{category_id}/mark_as_active',
      MARK_SERVICE_CATEGORY_INACTIVE: '/tenants/{tenant_id}/service_categories/{category_id}/mark_as_inactive',
      GET_WAIVER_MASTERS: '/tenants/{tenant_id}/waiver_mst'
  },

  PLAN: {
      GET_SUBSCRIPTION_PLANS: '/tenants/{tenant_id}/subscription_plans',
      GET_SUBSCRIPTION_PLAN_BY_ID: '/tenants/{tenant_id}/subscription_plans/{plan_id}',
      GET_PLAN_ELIGIBLE_ADDONS: '/tenants/{tenant_id}/subscription_plans/{plan_id}/eligible_addons',
      CREATE_SUBSCRIPTION_PLAN: '/tenants/{tenant_id}/subscription_plans',
      UPDATE_SUBSCRIPTION_PLAN: '/tenants/{tenant_id}/subscription_plans/{plan_id}',
      MARK_SUBSCRIPTION_PLAN_ACTIVE: '/tenants/{tenant_id}/subscription_plans/mark_as_active',
      MARK_SUBSCRIPTION_PLAN_INACTIVE: '/tenants/{tenant_id}/subscription_plans/mark_as_inactive',
      GET_SUBSCRIPTION_PLAN_CLIENTS: '/tenants/{tenant_id}/subscription_plans/{plan_id}/clients',
      RESEND_PAYMENT_LINK: '/subscription/signup/{signup_uuid}/tenants/{tenant_id}/clients/{client_id}/send_payment_link',
      VOID_SIGNUP: '/tenants/{tenant_id}/clients/{client_id}/subscription_signups/{signup_id}/void',
      VOID_UPGRADE_SUBSCRIPTION: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/voidupgrade',
      
      // Upgrade Calculations
      UPGRADE_CALCULATION: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/upgrade_calculation',
      UPGRADE_STAFF_DISCOUNT_CALCULATION: '/tenants/{tenant_id}/upgrade/{plan_id}/staff_discount_calculation',

      // Subscription Amendment
      AMENDMENT_PREVIEW: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/amendment-preview',
      EXECUTE_AMENDMENT: '/tenants/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/amend',

      // Plan Breakup Calculations
      PLAN_BREAKUP_CALCULATION: '/tenants/{tenant_id}/subscription_plans/{plan_id}/plan_breakup_calculation',
      STAFF_DISCOUNT_CALCULATION: '/tenants/{tenant_id}/subscription_plans/{plan_id}/staff_discount_calculation',
      SUBSCRIPTION_SIGNUP: '/tenants/{tenant_id}/clients/{client_id}/subscription_signups',
      MID_CYCLE_ADDON_BREAKUP: '/tenant/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/mid_cycle_addons/breakup_calculation',
      MID_CYCLE_ADDON: '/tenant/{tenant_id}/clients/{client_id}/subscriptions/{subscription_id}/mid_cycle_addons'
  },

  CHARGES: {
      CREATE_CHARGES: '/tenants/{tenant_id}/clients/{client_id}/charges/createcharges',
      CHARGE_BREAKUP_CALCULATION: '/tenants/{tenant_id}/charges/retail_and_charges_breakup_calculation',
      CHARGE_STAFF_DISCOUNT_CALCULATION: '/tenants/{tenant_id}/charges/staff_discount_calculation'
  },

  ORGANIZATION: {
      GET_ORGANIZATIONS: '/tenants/{tenant_id}/organisation',
      GET_ORGANIZATION_BY_ID: '/tenants/{tenant_id}/organisation/{organization_id}',
      CREATE_ORGANIZATION: '/tenants/{tenant_id}/organisation',
      UPDATE_ORGANIZATION: '/tenants/{tenant_id}/organisation/{organization_id}',
      MARK_ORGANIZATION_ACTIVE: '/tenants/{tenant_id}/organisation/{organization_id}/mark_as_active',
      MARK_ORGANIZATION_INACTIVE: '/tenants/{tenant_id}/organisation/{organization_id}/mark_as_inactive'
  },

  ATTACHMENT: {
      // Document Types (Attachment Master)
      GET_ATTACHMENTS: '/tenants/{tenant_id}/document_types',
      GET_ATTACHMENT_BY_ID: '/tenants/{tenant_id}/document_types/{attachment_id}',
      CREATE_ATTACHMENT: '/tenants/{tenant_id}/document_types',
      UPDATE_ATTACHMENT: '/tenants/{tenant_id}/document_types/{attachment_id}',
      MARK_ATTACHMENT_ACTIVE: '/tenants/{tenant_id}/document_types/{attachment_id}/mark_as_active',
      MARK_ATTACHMENT_INACTIVE: '/tenants/{tenant_id}/document_types/{attachment_id}/mark_as_inactive',
      DELETE_ATTACHMENT: '/tenants/{tenant_id}/document_types/{attachment_id}',
      
      // Client Documents
      UPLOAD_DOCUMENT: '/tenants/{tenant_id}/clients/{client_id}/documents',
      GET_DOCUMENTS: '/clients/{client_id}/documents',
      GET_WAIVERS_DOCUMENTS: '/tenants/{tenant_id}/clients/{client_id}/waivers',
      GET_CLIENTS_WAIVER_DOCUMENTS: '/clients/{client_id}/waivers',
      GET_SINGLE_DOCUMENT: '/clients/{client_id}/documents/{document_id}',
      DELETE_DOCUMENT: '/tenants/{tenant_id}/clients/{client_id}/documents/{document_id}'
  },

  TAX: {
      GET_TAX_GROUPS: '/tenants/{tenant_id}/tax_groups',
      GET_TAX_SETTING: '/tenants/{tenant_id}/tenant_settings/{setting_key}',
      GET_ALL_TAX_SETTINGS: '/tenants/{tenant_id}/tenant_settings',
      UPDATE_TAX_SETTINGS: '/tenants/{tenant_id}/tenant_settings/update',
      GET_TAX_LINE_ITEMS: '/tenants/{tenant_id}/tax_groups/{group_id}/tax_line_items',
      GET_TAX_LINE_ITEM_BY_ID: '/tenants/{tenant_id}/tax_groups/{group_id}/tax_line_items/{line_item_id}',
      GET_TAX_LINE_ITEM_TYPES: '/tenants/{tenant_id}/tax_line_type',
      CREATE_TAX_GROUP: '/tenants/{tenant_id}/tax_groups',
      CREATE_TAX_LINE_ITEM: '/tenants/{tenant_id}/tax_groups/{group_id}/tax_line_items',
      UPDATE_TAX_GROUP: '/tenants/{tenant_id}/tax_groups/{group_id}',
      UPDATE_TAX_LINE_ITEM: '/tenants/{tenant_id}/tax_groups/{group_id}/tax_line_items/{line_item_id}',
      DELETE_TAX_GROUP: '/tenants/{tenant_id}/tax_groups/{group_id}'
  },

  PAYMENT: {
      CREATE_PAYMENT_GATEWAY: '/tenants/{tenant_id}/pgw_config_master',
      ENABLE_PAYENGINE: '/tenants/{tenant_id}/enable_pe',
      UPDATE_PAYMENT_GATEWAY: '/tenants/{tenant_id}/pgw_config_master/{gateway_id}',
      GET_PAYMENT_GATEWAYS: '/tenants/{tenant_id}/pgw_config_master',
      GET_PAYMENT_GATEWAY_BY_ID: '/tenants/{tenant_id}/pgw_config_master/{gateway_id}',
      GET_PAYMENT_GATEWAY_HMAC: '/tenants/{tenant_id}/pgw_config_master/hmac',
      UPDATE_PAYMENT_GATEWAY_STATUS: '/tenants/{tenant_id}/pgw_config_master/{gateway_id}/{status}',
      DELETE_PAYMENT_GATEWAY: '/tenants/{tenant_id}/pgw_config_master/{gateway_id}',
      GET_PAYMENT_MODES: '/tenants/{tenant_id}/payment_mode_master',
      GET_PAYMENT_MODE_BY_ID: '/tenants/{tenant_id}/payment_mode_master/{mode_id}',
      CREATE_PAYMENT_MODE: '/tenants/{tenant_id}/payment_mode_master',
      UPDATE_PAYMENT_MODE: '/tenants/{tenant_id}/payment_mode_master/{mode_id}',
      MARK_PAYMENT_MODE_ACTIVE: '/tenants/{tenant_id}/payment_mode_master/{mode_id}/mark_as_active',
      MARK_PAYMENT_MODE_INACTIVE: '/tenants/{tenant_id}/payment_mode_master/{mode_id}/mark_as_inactive',
      DELETE_PAYMENT_MODE: '/tenants/{tenant_id}/payment_mode_master/{mode_id}',
      GET_PAYMENT_GATEWAYS_LIST: '/tenants/{tenant_id}/payment_gateways',
      GET_PAYMENT_GATEWAY_DETAILS: '/tenants/{tenant_id}/payment_gateways/{gateway_id}',
      CREATE_PAYMENT_GATEWAY_CONFIG: '/tenants/{tenant_id}/payment_gateways',
      GET_SETTLEMENTS: '/tenants/{tenant_id}/pos/settlements',
      EXPORT_SETTLEMENTS: '/tenants/{tenant_id}/pos/settlements/export',
      DOWNLOAD_SETTLEMENT_BY_ID: '/tenants/{tenant_id}/pos/settlements/{settlement_id}',
      POS_TERMINAL_REGISTER: '/tenants/{tenant_id}/pos_terminals/register',
      POS_TERMINAL_LIST: '/tenants/{tenant_id}/pos_terminals',
      POS_TERMINAL_GET_BY_ID: '/tenants/{tenant_id}/pos_terminals/{id}',
      POS_TERMINAL_DEACTIVATE: '/tenants/{tenant_id}/pos_terminals/{id}/deactivate'
  },

  REPORTS: {
      DOWNLOAD_REPORT_EXCEL: '/tenants/{tenant_id}/reports/{report_key}/excel',
      GET_REPORT_FILTERS: '/tenants/{tenant_id}/reports/{report_key}/filter',
      CREATE_REPORT_FILTER: '/tenants/{tenant_id}/reports/{report_key}/filter',
      UPDATE_REPORT_FILTER: '/tenants/{tenant_id}/reports/{report_key}/filters/{filter_id}',
      DELETE_REPORT_FILTER: '/tenants/{tenant_id}/reports/{report_key}/filters/{report_id}',
      SCHEDULE_REPORT_FILTER: '/tenants/{tenant_id}/reports/{report_key}/filters/{filter_id}/schedules',
      CREATE_LONG_REPORT: '/tenants/{tenant_id}/reports/{report_key}/long_report',
      DELETE_SCHEDULE_FILTER: '/tenants/{tenant_id}/reports/{report_key}/filters/{filter_id}/schedules/{schedule_id}'
  },

  CLIENT_EXPORT: {
      EXPORT_PROSPECTS: '/tenants/{tenant_id}/prospects/export',
      EXPORT_ACTIVE_CLIENTS: '/tenants/{tenant_id}/activeclients/export',
      EXPORT_EX_CLIENTS: '/tenants/{tenant_id}/exclients/export',
      EXPORT_CLIENTS_AT_RISK: '/tenants/{tenant_id}/clients/client_at_risk/export',
      EXPORT_TRIALS: '/tenants/{tenant_id}/trials/export'
  },

  CAMPAIGN: {
      GET_CAMPAIGN: '/tenants/{tenant_id}/campaigns/{campaign_id}',
      GET_CAMPAIGNS: '/tenants/{tenant_id}/campaigns',
      CREATE_WEBHOOK_AUTOMATION: '/tenants/{tenant_id}/webhook-automation',
      GET_WEBHOOK_AUTOMATION: '/tenants/{tenant_id}/webhook-automation',
      GET_BLACKOUT_CONFIGS: '/tenants/{tenant_id}/blackout-configs',
      LIST_BLACKOUT_CONFIGS: '/tenants/{tenant_id}/blackout-configs',
      CREATE_BLACKOUT_CONFIG: '/tenants/{tenant_id}/blackout-configs',
      GET_BLACKOUT_CONFIG: '/tenants/{tenant_id}/blackout-configs/{config_id}',
      UPDATE_BLACKOUT_CONFIG: '/tenants/{tenant_id}/blackout-configs/{config_id}',
      ACTIVATE_BLACKOUT_CONFIG: '/tenants/{tenant_id}/blackout-configs/{config_id}/mark_as_active',
      DEACTIVATE_BLACKOUT_CONFIG: '/tenants/{tenant_id}/blackout-configs/{config_id}/mark_as_inactive'
  },

  AUTOMATION: {
      GET_AUTOMATION_MASTER: '/tenants/{tenant_id}/automation_master/{event_type}'
  },

  WAIVER: {
      GET_WAIVERS: '/tenants/{tenant_id}/waiver_mst',
      GET_WAIVER_BY_ID: '/tenants/{tenant_id}/waiver_mst/{waiver_id}',
      CREATE_WAIVER: '/tenants/{tenant_id}/waiver_mst',
      UPDATE_WAIVER: '/tenants/{tenant_id}/waiver_mst/{waiver_id}',
      MARK_WAIVER_ACTIVE: '/tenants/{tenant_id}/waiver_mst/{waiver_id}/mark_as_active',
      MARK_WAIVER_INACTIVE: '/tenants/{tenant_id}/waiver_mst/{waiver_id}/mark_as_inactive'
  },

  TRIAL: {
      GET_TRIALS: '/tenants/{tenant_id}/trial_mst',
      GET_TRIAL_BY_ID: '/tenants/{tenant_id}/trial_mst/{trial_id}',
      CREATE_TRIAL: '/tenants/{tenant_id}/trial_mst',
      UPDATE_TRIAL: '/tenants/{tenant_id}/trial_mst/{trial_id}',
      MARK_TRIAL_ACTIVE: '/tenants/{tenant_id}/trial_mst/{trial_id}/mark_as_active',
      MARK_TRIAL_INACTIVE: '/tenants/{tenant_id}/trial_mst/{trial_id}/mark_as_inactive',
      GET_TRIAL_CLIENTS: '/tenants/{tenant_id}/trials'
  },

  PROFILING: {
      CREATE_MANDATORY_FIELD: '/tenants/{tenant_id}/clients/mandatory_client_fields',
      UPDATE_MANDATORY_FIELD: '/tenants/{tenant_id}/clients/mandatory_client_fields/{field_id}',
      GET_MANDATORY_FIELDS: '/tenants/{tenant_id}/clients/mandatory_client_fields'
  },

  PARTNER: {
      GET_PARTNERS: '/tenants/{tenant_id}/our_partners',
      GET_PARTNER_BY_ID: '/tenants/{tenant_id}/our_partners/{partner_id}',
      CREATE_PARTNER: '/tenants/{tenant_id}/our_partners',
      UPDATE_PARTNER: '/tenants/{tenant_id}/our_partners/{partner_id}'
  },

  WHATSAPP_CONFIG: {
      GET_WHATSAPP_CONFIG: '/tenants/{tenant_id}/whatsapp_config_master/{config_id}',
      ENABLE_WHATSAPP_CONFIG: '/tenants/{tenant_id}/whatsapp_config_master/enable',
      UPDATE_WHATSAPP_CONFIG: '/tenants/{tenant_id}/whatsapp_config_master',
      GET_WHATSAPP_CONFIGS: '/tenants/{tenant_id}/whatsapp_config_master'
  },

  WEBHOOK_CONFIG: {
      GET_WEBHOOK_CONFIGS: '/tenants/{tenant_id}/webhook_config_mst',
      CREATE_WEBHOOK_CONFIG: '/tenants/{tenant_id}/webhook_config_mst',
      UPDATE_WEBHOOK_CONFIG: '/tenants/{tenant_id}/webhook_config_mst/{webhook_id}'
  },


  CLASS_TYPE: {
      CREATE_CLASS_TYPE: '/tenants/{tenant_id}/class_types',
      UPDATE_CLASS_TYPE: '/tenants/{tenant_id}/class_types/{class_type_id}',
      GET_CLASS_TYPES: '/tenants/{tenant_id}/class_types',
      GET_CLASS_TYPE_BY_ID: '/tenants/{tenant_id}/class_types/{class_type_id}',
      MARK_CLASS_TYPE_ACTIVE: '/tenants/{tenant_id}/class_types/{class_type_id}/mark_as_active',
      MARK_CLASS_TYPE_INACTIVE: '/tenants/{tenant_id}/class_types/{class_type_id}/mark_as_inactive',
      GET_CLASS_TAGS: '/tenants/{tenant_id}/class_appt_tags'
  },

  CHECK_IN: {
      CREATE_CHECK_IN: '/tenants/{tenant_id}/check_ins',
      UPDATE_CHECK_IN: '/tenants/{tenant_id}/check_ins/{check_in_id}',
      GET_CHECK_INS: '/tenants/{tenant_id}/check_ins',
      GET_CHECK_IN_BY_ID: '/tenants/{tenant_id}/check_ins/{check_in_id}',
      DELETE_CHECK_IN: '/tenants/{tenant_id}/clients/{client_id}/check_ins/{check_in_id}',
      GET_WHO_IS_IN_CLUB: '/tenants/{tenant_id}/clients/who_is_in_club',
      GET_CLIENT_CHECK_INS: '/tenants/{tenant_id}/clients/check_ins',
      MARK_CLIENT_CHECKED_IN: '/tenants/{tenant_id}/clients/{client_id}/mark_client_checkedin'
  },

  CHARGE_CATEGORY: {
      CREATE_CHARGE_CATEGORY: '/tenants/{tenant_id}/charge_category_master',
      UPDATE_CHARGE_CATEGORY: '/tenants/{tenant_id}/charge_category_master/{category_id}',
      GET_CHARGE_CATEGORIES: '/tenants/{tenant_id}/charge_category_master',
      GET_CHARGE_CATEGORY_BY_ID: '/tenants/{tenant_id}/charge_category_master/{category_id}',
      MARK_CHARGE_CATEGORY_ACTIVE: '/tenants/{tenant_id}/charge_category_master/{category_id}/mark_as_active',
      MARK_CHARGE_CATEGORY_INACTIVE: '/tenants/{tenant_id}/charge_category_master/{category_id}/mark_as_inactive'
  },

  BIOSTAR_ENROLLMENT: {
      GET_ENROLLMENT_STATUS: '/tenants/{tenant_id}/clients/{client_id}/suprema_enrolment',
      GET_SUPREMA_DEVICES: '/tenants/{tenant_id}/suprema_devices',
      SCAN_CREDENTIAL: '/tenants/{tenant_id}/suprema_devices/{device_id}/clients/{client_id}/scan',
      SAVE_ENROLLMENT: '/tenants/{tenant_id}/clients/{client_id}/suprema_enrol',
      CLEAR_ENROLLMENT: '/tenants/{tenant_id}/clients/{client_id}/suprema_enrolment'
  },

  ACCESS_CONTROL: {
      GET_TENANT_CONFIG: '/tenants/{tenant_id}/access_control_config',
      REACTIVATE_CLIENT: '/tenants/{tenant_id}/clients/{client_id}/access_control/reactivate'
  },

  ADVANCED_SETTING: {
      GET_ADVANCED_SETTING: '/tenants/{tenant_id}/tenant_settings/{setting_key}',
      GET_ADVANCED_SETTINGS: '/tenants/{tenant_id}/tenant_settings',
      UPDATE_ADVANCED_SETTINGS: '/tenants/{tenant_id}/tenant_settings/update'
  },

  COMPANY_SETTING: {
      GET_COMPANY_SETTING: '/companies/company_settings/{compstg_key}',
      GET_COMPANY_SETTINGS: '/companies/company_settings',
      UPDATE_COMPANY_SETTINGS: '/companies/company_settings/update'
  },

  AD_HOC: {
      CREATE_AD_HOC: '/tenants/{tenant_id}/adhoc_charges',
      UPDATE_AD_HOC: '/tenants/{tenant_id}/adhoc_charges/{ad_hoc_id}',
      GET_AD_HOCS: '/tenants/{tenant_id}/adhoc_charges'
  },

  FACEBOOK_CUSTOM_AUDIENCE: {
      GET_CUSTOM_AUDIENCES: '/tenants/{tenant_id}/custom_audience',
      GET_CUSTOM_AUDIENCE_BY_ID: '/tenants/{tenant_id}/custom_audience/{config_id}',
      CREATE_CUSTOM_AUDIENCE: '/tenants/{tenant_id}/custom_audience',
      UPDATE_CUSTOM_AUDIENCE: '/tenants/{tenant_id}/custom_audience/{config_id}',
      ACTIVE_CUSTOM_AUDIENCE: '/tenants/{tenant_id}/custom_audience/{config_id}/active',
      INACTIVE_CUSTOM_AUDIENCE: '/tenants/{tenant_id}/custom_audience/{config_id}/in_active'
  },

  APPOINTMENT_TYPE: {
      MARK_APPOINTMENT_TYPE_ACTIVE: '/tenants/{tenant_id}/appointment_types/{appt_type_id}/mark_as_active',
      MARK_APPOINTMENT_TYPE_INACTIVE: '/tenants/{tenant_id}/appointment_types/{appt_type_id}/mark_as_inactive'
  },


  FREEZE_REASON: {
      CREATE_FREEZE_REASON: '/tenants/{tenant_id}/freeze/reasons',
      GET_FREEZE_REASONS: '/tenants/{tenant_id}/freeze/reasons',
      GET_FREEZE_REASON_BY_ID: '/tenants/{tenant_id}/freeze/reasons/{reason_id}',
      UPDATE_FREEZE_REASON: '/tenants/{tenant_id}/freeze/reasons/{reason_id}',
      MARK_FREEZE_REASON_ACTIVE: '/tenants/{tenant_id}/freeze/reasons/{reason_id}/mark_as_active',
      MARK_FREEZE_REASON_INACTIVE: '/tenants/{tenant_id}/freeze/reasons/{reason_id}/mark_as_inactive',
      DELETE_FREEZE_REASON: '/tenants/{tenant_id}/freeze/reasons/{reason_id}'
  },

  CANCELLATION_REASON: {
      LIST: '/tenants/{tenant_id}/cancellation_reasons',
      CREATE: '/tenants/{tenant_id}/cancellation_reasons',
      GET_BY_ID: '/tenants/{tenant_id}/cancellation_reasons/{cancellation_reason_id}',
      UPDATE: '/tenants/{tenant_id}/cancellation_reasons/{cancellation_reason_id}',
      DELETE: '/tenants/{tenant_id}/cancellation_reasons/{cancellation_reason_id}',
      MARK_ACTIVE: '/tenants/{tenant_id}/cancellation_reasons/{cancellation_reason_id}/mark_as_active',
      MARK_INACTIVE: '/tenants/{tenant_id}/cancellation_reasons/{cancellation_reason_id}/mark_as_inactive',
  },

  SUBSCRIPTION_CANCELLATION: {
      PENDING_REQUESTS: '/tenants/{tenant_id}/subscriptions/cancellation_request',
      NOT_RENEWING: '/tenants/{tenant_id}/subscriptions/not_renewing',
      RECENT_CANCELLATIONS: '/tenants/{tenant_id}/subscriptions/cancellations',
      APPROVE: '/tenants/{tenant_id}/subscriptions/cancellation_request/{request_id}/approve',
      REJECT: '/tenants/{tenant_id}/subscriptions/cancellation_request/{request_id}/reject',
  },

  INVOICE_ADDITIONAL: {
      SEND_INVOICE_CLEAR_BALANCE_LINK: '/tenant/{tenant_id}/clients/{client_id}/invoices/{invoice_id}/send_invoice_clear_balance_link'
  },

  SPONSOR_CONTRACT: {
      GET_TENANT_CONTRACTS: '/tenants/{tenant_id}/sponsorContracts',
      GET_TENANT_CONTRACT_BY_ID: '/tenants/{tenant_id}/sponsorContracts/{contract_id}',
      CREATE_TENANT_CONTRACT: '/tenants/{tenant_id}/sponsorContracts',
      UPDATE_TENANT_CONTRACT: '/tenants/{tenant_id}/sponsorContracts/{contract_id}',
      GET_SPONSORS: '/tenants/{tenant_id}/corporate',
      GET_SUBSCRIPTION_PLANS: '/tenants/{tenant_id}/subscription_plans',
      MARK_CONTRACT_ACTIVE: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/mark-as-active',
      MARK_CONTRACT_DRAFT: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/mark-as-draft',
      GET_CONTRACT_CLIENTS: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/clients',
      GET_CONTRACT_DRAFT_INVOICES: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/draft_invoices',
      GENERATE_DRAFT_INVOICE: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/drafts/generate_draft_invoice',
      GET_DRAFT_BY_ID: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/draft_invoices/{draft_id}',
      UPDATE_DRAFT_INVOICE: '/tenants/{tenant_id}/sponsorContracts/{contract_id}/draft-invoices/{draft_id}'
  },

  DASHBOARD_WIDGETS: {
      GET_LIVE_CLIENTS: '/tenants/{tenant_id}/live_client',
      GET_TOTAL_REVENUE: '/tenants/{tenant_id}/total_revenue',
      GET_RECENT_PROSPECTS: '/tenants/{tenant_id}/prospects',
      GET_RECENT_SIGNUPS: '/tenants/{tenant_id}/recent_signups',
      GET_UPCOMING_CLASSES: '/tenants/{tenant_id}/classes',
      GET_UPCOMING_RENEWALS: '/tenants/{tenant_id}/reports/{report_key}'
  },

  RETAIL_PRODUCTS: {
      GET_RETAIL_PRODUCT_SKUS: '/tenants/{tenant_id}/retail_products/skus'
  },

  // Company-level resources (plural - master data and configurations)
  COMPANIES: {
      // Automation
      GET_AUTOMATION_TYPES: '/companies/automations/automation_type',
      
      // Email Templates
      GET_EMAIL_TEMPLATES: '/companies/email_template_master',
      GET_EMAIL_TEMPLATE_BY_ID: '/companies/email_template_master/{template_id}',
      MARK_EMAIL_TEMPLATE_ACTIVE: '/companies/email_template_master/{template_id}/mark_as_active',
      MARK_EMAIL_TEMPLATE_INACTIVE: '/companies/email_template_master/{template_id}/mark_as_inactive',
      CREATE_EMAIL_TEMPLATE: '/companies/email_template_master',
      UPDATE_EMAIL_TEMPLATE: '/companies/email_template_master/{template_id}',
      
      // Email From Config
      GET_EMAIL_FROM_CONFIGS: '/companies/email_from_config_master',
      
      // SMS Sender Config
      GET_SMS_SENDER_CONFIGS: '/companies/sms_sender_config_master',
      
      // SMS Templates
      GET_SMS_TEMPLATES: '/companies/sms_template_master',
      GET_SMS_TEMPLATE_BY_ID: '/companies/sms_template_master/{template_id}',
      MARK_SMS_TEMPLATE_ACTIVE: '/companies/sms_template_master/{template_id}/mark_as_active',
      MARK_SMS_TEMPLATE_INACTIVE: '/companies/sms_template_master/{template_id}/mark_as_inactive',
      CREATE_SMS_TEMPLATE: '/companies/sms_template_master',
      UPDATE_SMS_TEMPLATE: '/companies/sms_template_master/{template_id}',
      
      // WhatsApp Templates
      GET_WHATSAPP_TEMPLATES: '/companies/whatsapp_template_master',
      GET_WHATSAPP_TEMPLATE_BY_ID: '/companies/whatsapp_template_master/{template_id}',
      MARK_WHATSAPP_TEMPLATE_ACTIVE: '/companies/whatsapp_template_master/{template_id}/mark_as_active',
      MARK_WHATSAPP_TEMPLATE_INACTIVE: '/companies/whatsapp_template_master/{template_id}/mark_as_inactive',
      CREATE_WHATSAPP_TEMPLATE: '/companies/whatsapp_template_master',
      UPDATE_WHATSAPP_TEMPLATE: '/companies/whatsapp_template_master/{template_id}',
      
      // WhatsApp Config
      GET_WHATSAPP_CONFIGS: '/companies/whatsapp_config_master',
      
      // Push Notification Templates
      GET_PUSH_TEMPLATES: '/companies/push_notification_template_master',
      GET_PUSH_TEMPLATE_BY_ID: '/companies/push_notification_template_master/{template_id}',
      MARK_PUSH_TEMPLATE_ACTIVE: '/companies/push_notification_template_master/{template_id}/mark_as_active',
      MARK_PUSH_TEMPLATE_INACTIVE: '/companies/push_notification_template_master/{template_id}/mark_as_inactive',
      CREATE_PUSH_TEMPLATE: '/companies/push_notification_template_master',
      UPDATE_PUSH_TEMPLATE: '/companies/push_notification_template_master/{template_id}',
      
      // Class Types
      GET_CLASS_TYPES: '/companies/class_types',
      
      // Retail Products
      GET_RETAIL_PRODUCT_SKUS: '/companies/retail_product_skus',
      
      // Webhook Config
      GET_WEBHOOK_CONFIGS: '/companies/webhook_config_mst',
      CREATE_WEBHOOK_CONFIG: '/companies/webhook_config_mst',
      UPDATE_WEBHOOK_CONFIG: '/companies/webhook_config_mst/{webhook_id}',
      
      // Webhook Automation
      GET_WEBHOOK_AUTOMATION: '/companies/webhook-automation',
      
      // Subscription Plans
      GET_SUBSCRIPTION_PLANS: '/companies/subscription_plans',

      // Service categories (ownership-scoped, optional ?behaviour=)
      GET_SERVICE_CATEGORIES: '/companies/service_categories',
      
      // Open API (public endpoints)
      GET_COMPANY_BY_UUID: '/open/companies/{uuid}',
      
      // Get Company by ID
      GET_COMPANY_BY_ID: '/companies/{company_id}',
      
      // Analytics
      GET_TOTAL_SALES_AND_PAYMENTS: '/companies/analytics/total_sales_and_payments',
      
      // Client Stats
      GET_CLIENT_SOURCE_STATS: '/companies/clients/source-stats',
      
      // SKU Return Reasons
      GET_SKU_RETURN_REASONS: '/companies/sku-return-reasons',
      
      // Sponsor Contracts (Company Level)
      GET_COMPANY_SPONSOR_CONTRACTS: '/companies/sponsorContracts',
      GET_COMPANY_SPONSOR_CONTRACT_BY_ID: '/companies/sponsorContracts/{contract_id}',
      CREATE_COMPANY_SPONSOR_CONTRACT: '/companies/sponsorContracts',
      UPDATE_COMPANY_SPONSOR_CONTRACT: '/companies/sponsorContracts/{contract_id}',
      MARK_COMPANY_CONTRACT_ACTIVE: '/companies/sponsorContracts/{contract_id}/mark-as-active',
      MARK_COMPANY_CONTRACT_DRAFT: '/companies/sponsorContracts/{contract_id}/mark-as-draft',
      GET_COMPANY_CONTRACT_CLIENTS: '/companies/sponsorContracts/{contract_id}/clients',
      GET_COMPANY_CONTRACT_DRAFT_INVOICES: '/companies/sponsorContracts/{contract_id}/draft_invoices',
      GENERATE_COMPANY_DRAFT_INVOICE: '/companies/sponsorContracts/{contract_id}/drafts/generate_draft_invoice',
      GET_COMPANY_DRAFT_BY_ID: '/companies/sponsorContracts/{contract_id}/draft_invoices/{draft_id}',
      UPDATE_COMPANY_DRAFT_INVOICE: '/companies/sponsorContracts/{contract_id}/draft-invoices/{draft_id}',
      
      // Commission Plans - Staff Assignments
      GET_COMMISSION_PLAN_STAFF_ASSIGNMENTS: '/companies/commission-plans/{plan_id}/staff-assignments',
      CREATE_COMMISSION_PLAN_STAFF_ASSIGNMENT: '/companies/commission-plans/{plan_id}/staff-assignments',
      DELETE_COMMISSION_PLAN_STAFF_ASSIGNMENT: '/companies/commission-plans/{plan_id}/staff-assignments/{assignment_id}',
      
      // Commission Plans - Active Rules
      GET_ACTIVE_COMMISSION_PLAN_RULES: '/companies/commission-plans/{plan_id}/rules/active',
      
      // Commission Plans - Active Slabs
      GET_ACTIVE_COMMISSION_PLAN_SLABS: '/companies/commission-plans/{plan_id}/rules/{rule_id}/slabs/active'
  },

  // Company-scoped operations (singular - campaigns and automations)
  COMPANY: {
      // Campaign
      CREATE_CAMPAIGN: '/company/campaign',
      MARK_CAMPAIGN_ACTIVE: '/company/campaign/{campaign_guid}/mark_as_active',
      MARK_CAMPAIGN_INACTIVE: '/company/campaign/{campaign_guid}/mark_as_inactive',
      MARK_CAMPAIGN_STOP: '/company/campaign/{campaign_guid}/mark_as_stop',
      MARK_CAMPAIGN_VOID: '/company/campaign/{campaign_guid}/mark_as_void',
      
      // Automation
      CREATE_AUTOMATION: '/company/automation',
      GET_AUTOMATION_BY_UUID: '/company/automation/{uuid}',
      UPDATE_AUTOMATION: '/company/automation/{uuid}',
      MARK_AUTOMATION_ACTIVE: '/company/automation/{uuid}/mark_as_active',
      MARK_AUTOMATION_INACTIVE: '/company/automation/{uuid}/mark_as_inactive',
      GET_COMPANY_AUTOMATIONS: '/company/automation/ownership/company',
      GET_FRANCHISE_AUTOMATIONS: '/company/automation/ownership/franchise/{franchise_id}',
      GET_TENANT_AUTOMATIONS: '/company/automation/ownership/tenant/{tenant_id}'
  },

  // Franchise Group resources
  FRANCHISE_GROUP: {
      // WhatsApp Config
      GET_WHATSAPP_CONFIG: '/franchise_group/{franchise_group_id}/whatsapp_config_master',
      
      // Webhook Automation
      GET_WEBHOOK_AUTOMATION: '/franchise_group/{franchise_group_id}/webhook-automation',
      
      // Webhook Config
      GET_WEBHOOK_CONFIGS: '/franchise_group/{franchise_group_id}/webhook_config_mst',
      CREATE_WEBHOOK_CONFIG: '/franchise_group/{franchise_group_id}/webhook_config_mst',
      UPDATE_WEBHOOK_CONFIG: '/franchise_group/{franchise_group_id}/webhook_config_mst/{webhook_id}',
      
      // Email Templates
      GET_EMAIL_TEMPLATES: '/franchise_group/{franchise_group_id}/email_template_master',
      GET_EMAIL_TEMPLATE_BY_ID: '/franchise_group/{franchise_group_id}/email_template_master/{template_id}',
      MARK_EMAIL_TEMPLATE_ACTIVE: '/franchise_group/{franchise_group_id}/email_template_master/{template_id}/mark_as_active',
      MARK_EMAIL_TEMPLATE_INACTIVE: '/franchise_group/{franchise_group_id}/email_template_master/{template_id}/mark_as_inactive',
      CREATE_EMAIL_TEMPLATE: '/franchise_group/{franchise_group_id}/email_template_master',
      UPDATE_EMAIL_TEMPLATE: '/franchise_group/{franchise_group_id}/email_template_master/{template_id}',
      
      // Email From Config
      GET_EMAIL_FROM_CONFIGS: '/franchise_group/{franchise_group_id}/email_from_config_master',
      
      // SMS Sender Config
      GET_SMS_SENDER_CONFIGS: '/franchise_group/{franchise_group_id}/sms_sender_config_master',
      
      // SMS Templates
      GET_SMS_TEMPLATES: '/franchise_group/{franchise_group_id}/sms_template_master',
      GET_SMS_TEMPLATE_BY_ID: '/franchise_group/{franchise_group_id}/sms_template_master/{template_id}',
      MARK_SMS_TEMPLATE_ACTIVE: '/franchise_group/{franchise_group_id}/sms_template_master/{template_id}/mark_as_active',
      MARK_SMS_TEMPLATE_INACTIVE: '/franchise_group/{franchise_group_id}/sms_template_master/{template_id}/mark_as_inactive',
      CREATE_SMS_TEMPLATE: '/franchise_group/{franchise_group_id}/sms_template_master',
      UPDATE_SMS_TEMPLATE: '/franchise_group/{franchise_group_id}/sms_template_master/{template_id}',
      
      // WhatsApp Templates
      GET_WHATSAPP_TEMPLATES: '/franchise_group/{franchise_group_id}/whatsapp_template_master',
      GET_WHATSAPP_TEMPLATE_BY_ID: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}',
      MARK_WHATSAPP_TEMPLATE_ACTIVE: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}/mark_as_active',
      MARK_WHATSAPP_TEMPLATE_INACTIVE: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}/mark_as_inactive',
      CREATE_WHATSAPP_TEMPLATE: '/franchise_group/{franchise_group_id}/whatsapp_template_master',
      UPDATE_WHATSAPP_TEMPLATE: '/franchise_group/{franchise_group_id}/whatsapp_template_master/{template_id}',
      
      // Push Notification Templates
      GET_PUSH_TEMPLATES: '/franchise_group/{franchise_group_id}/push_notification_template_master',
      GET_PUSH_TEMPLATE_BY_ID: '/franchise_group/{franchise_group_id}/push_notification_template_master/{template_id}',
      MARK_PUSH_TEMPLATE_ACTIVE: '/franchise_group/{franchise_group_id}/push_notification_template_master/{template_id}/mark_as_active',
      MARK_PUSH_TEMPLATE_INACTIVE: '/franchise_group/{franchise_group_id}/push_notification_template_master/{template_id}/mark_as_inactive',
      CREATE_PUSH_TEMPLATE: '/franchise_group/{franchise_group_id}/push_notification_template_master',
      UPDATE_PUSH_TEMPLATE: '/franchise_group/{franchise_group_id}/push_notification_template_master/{template_id}',

      // Subscription plans (ownership-scoped for commission rules)
      GET_SUBSCRIPTION_PLANS: '/franchise_group/{franchise_group_id}/subscription_plans',

      // Service categories (ownership-scoped, optional ?behaviour=)
      GET_SERVICE_CATEGORIES: '/franchise_group/{franchise_group_id}/service_categories'
  },

  // Franchise Group list
  FRANCHISE_GROUPS: {
      GET_FRANCHISE_GROUPS: '/franchisegroup'
  },

  // Survey/Forms Management
  SURVEY: {
      // Form Folders
      LIST_FORM_FOLDERS: '/tenants/{tenant_id}/form_folders',
      CREATE_FORM_FOLDER: '/tenants/{tenant_id}/form_folders',
      UPDATE_FORM_FOLDER: '/tenants/{tenant_id}/form_folders/{folder_id}',
      DELETE_FORM_FOLDER: '/tenants/{tenant_id}/form_folders/{folder_id}',
      
      // Form Templates
      LIST_FORM_TEMPLATES: '/tenants/{tenant_id}/form_templates',
      GET_FORM_TEMPLATE: '/tenants/{tenant_id}/form_templates/{template_id}',
      CREATE_FORM_TEMPLATE: '/tenants/{tenant_id}/form_templates',
      UPDATE_FORM_TEMPLATE: '/tenants/{tenant_id}/form_templates/{template_id}',
      DELETE_FORM_TEMPLATE: '/tenants/{tenant_id}/form_templates/{template_id}',
      MARK_TEMPLATE_AS_ACTIVE: '/tenants/{tenant_id}/form_templates/{template_id}/mark_as_active',
      MARK_TEMPLATE_AS_INACTIVE: '/tenants/{tenant_id}/form_templates/{template_id}/mark_as_inactive',
      
      // Form Responses (Staff/Admin side)
      CREATE_FORM_RESPONSE: '/tenants/{tenant_id}/form_responses',
      UPDATE_FORM_RESPONSE: '/tenants/{tenant_id}/form_responses/{response_id}',
      DELETE_FORM_RESPONSE: '/tenants/{tenant_id}/form_responses/{response_id}',
      GET_FORM_RESPONSE_CONTEXT: '/tenants/{tenant_id}/form_responses/{response_id}/context',
      GET_MEMBER_FORM_RESPONSES: '/tenants/{tenant_id}/form_responses/clients/{client_id}',
      SAVE_DRAFT_FORM_RESPONSE: '/tenants/{tenant_id}/form_responses/{response_id}/draft',
      COMPLETE_FORM_RESPONSE: '/tenants/{tenant_id}/form_responses/{response_id}/complete',
      
      // Form Responses (Public/Member-facing)
      GET_PUBLIC_FORM_RESPONSE: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/form_responses/{response_uuid}',
      SAVE_FORM_DRAFT: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/form_responses/{response_uuid}/draft',
      SUBMIT_FORM_COMPLETE: '/open/companies/{company_uuid}/tenants/{tenant_uuid}/form_responses/{response_uuid}/complete'
  },

  // Milestone Management
  MILESTONE_CONFIGURATIONS: {
      LIST: '/companies/milestones/configurations',
      CREATE: '/companies/milestones/configurations',
      GET_BY_ID: '/companies/milestones/configurations/{configId}',
      UPDATE: '/companies/milestones/configurations/{configId}',
      ACTIVATE: '/companies/milestones/configurations/{configId}/activate',
      DEACTIVATE: '/companies/milestones/configurations/{configId}/deactivate',
      FORCE_RECALCULATE: '/companies/milestones/configurations/{configId}/force_recalculate'
  },
  CLIENT_MILESTONES: {
      GET_PROGRESS: '/companies/milestones/clients/{clientId}/progress',
      GET_ACHIEVEMENTS: '/companies/milestones/clients/{clientId}/achievements',
      MANUALLY_AWARD: '/companies/milestones/clients/{clientId}/achievements',
      REVOKE_ACHIEVEMENT: '/companies/milestones/clients/{clientId}/achievements/{achievementId}'
  },

  COMMUNICATION_CATEGORIES: {
      LIST: '/companies/communication_categories',
      CREATE: '/companies/communication_categories',
      GET_BY_ID: '/companies/communication_categories/{communication_category_id}',
      UPDATE: '/companies/communication_categories/{communication_category_id}',
      DELETE: '/companies/communication_categories/{communication_category_id}',
      MARK_ACTIVE: '/companies/communication_categories/{communication_category_id}/mark_as_active',
      MARK_INACTIVE: '/companies/communication_categories/{communication_category_id}/mark_as_inactive'
  }
};
